<template>
  <section class="dp-layout htwa-config-page">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>
    <section class="dp-right config-page-right">
      <div v-if="!schoolId" class="empty-tip">
        <div class="empty-tip-inner">
          <i class="el-icon-school empty-icon"></i>
          <p class="empty-title">尚未选择学校</p>
          <p class="empty-desc">请从左侧机构树选择学校节点后再配置教职工工作考勤</p>
        </div>
      </div>

      <div v-else class="config-panel" v-loading="pageLoading">
        <div class="config-top-bar">
          <div class="org-display-card">
            <i class="el-icon-office-building org-icon"></i>
            <span class="org-label">当前学校：</span>
            <span class="org-value">{{ currentSchoolName || "—" }}</span>
          </div>
          <div class="top-hint">
            <i class="el-icon-info"></i>
            项目/时段删除均为软删除（列表中不再显示）；历史打卡明细仍可查。若需恢复请手工改库
          </div>
        </div>

        <el-tabs v-model="activeTab" class="htwa-tabs" @tab-click="onTabClick">
          <el-tab-pane label="考勤方案" name="plan">
            <div class="setting-grid setting-grid--plan">
              <div class="setting-card setting-card--plan">
                <header class="setting-card-head">
                  <span class="setting-card-icon setting-card-icon--plan"><i class="el-icon-s-tools"></i></span>
                  <div class="setting-card-head-text">
                    <span class="setting-card-name">方案设置</span>
                    <span class="setting-card-sub">控制全校教职工工作考勤总开关与补卡规则</span>
                  </div>
                </header>
                <div class="setting-body" v-loading="planLoading">
                  <div class="setting-row">
                    <div class="setting-row-text">
                      <div class="setting-row-label">方案名称</div>
                      <div class="setting-row-desc">展示给后台与统计口径使用</div>
                    </div>
            <el-input v-model="planForm.PlanName" maxlength="100" class="setting-control" placeholder="教职工工作考勤"></el-input>
                  </div>
                  <div class="setting-row">
                    <div class="setting-row-text">
                      <div class="setting-row-label">启用方案</div>
                      <div class="setting-row-desc">关闭后教师端不可打卡</div>
                    </div>
                    <el-switch v-model="planForm.IsEnabled" class="setting-row-switch"></el-switch>
                  </div>
                  <div class="setting-row">
                    <div class="setting-row-text">
                      <div class="setting-row-label">允许补卡</div>
                      <div class="setting-row-desc">开启后可在配置天数内补打历史时段</div>
                    </div>
                    <el-switch v-model="planForm.AllowMakeup" class="setting-row-switch"></el-switch>
                  </div>
                  <div class="setting-row" v-if="planForm.AllowMakeup">
                    <div class="setting-row-text">
                      <div class="setting-row-label">可补天数</div>
                      <div class="setting-row-desc">仅可补近 N 天内的记录</div>
                    </div>
                    <el-input-number v-model="planForm.MakeupDays" :min="1" :max="60" class="setting-control-num"></el-input-number>
                  </div>
                  <div class="setting-footer">
                    <el-button type="primary" icon="el-icon-check" :loading="planSaving" @click="savePlan">保存方案</el-button>
                  </div>
                </div>
              </div>

              <div class="setting-card setting-card--overview" v-loading="overviewLoading">
                <header class="setting-card-head">
                  <span class="setting-card-icon setting-card-icon--overview"><i class="el-icon-data-board"></i></span>
                  <div class="setting-card-head-text">
                    <span class="setting-card-name">配置总览</span>
                    <span class="setting-card-sub">卡片一览项目与时段，点「去配置」跳转编辑</span>
                  </div>
                  <el-button type="text" size="mini" class="overview-refresh" icon="el-icon-refresh" @click="loadConfigOverview">刷新</el-button>
                </header>
                <div class="overview-body">
                  <div class="overview-kpi">
                    <div class="overview-kpi-main">
                      <span class="overview-kpi-num">{{ configOverview.ItemCount || 0 }}</span>
                      <span class="overview-kpi-unit">个项目</span>
                      <span class="overview-kpi-split">/</span>
                      <span class="overview-kpi-num overview-kpi-num--accent">{{ configOverview.EnabledItemCount || 0 }}</span>
                      <span class="overview-kpi-unit">启用</span>
                    </div>
                    <div class="overview-kpi-side">
                      <span class="overview-kpi-pill">时段 {{ configOverview.ScheduleCount || 0 }}</span>
                      <span class="overview-kpi-pill overview-kpi-pill--ok">启用 {{ configOverview.EnabledScheduleCount || 0 }}</span>
                    </div>
                  </div>

                  <div class="overview-toolbar" v-if="configOverview.Items && configOverview.Items.length">
                    <el-radio-group v-model="overviewFilter" size="mini" @change="overviewPage = 1">
                      <el-radio-button label="all">全部</el-radio-button>
                      <el-radio-button label="ready">已配时段</el-radio-button>
                      <el-radio-button label="empty">未配时段</el-radio-button>
                    </el-radio-group>
                  </div>

                  <div v-if="!(configOverview.Items && configOverview.Items.length)" class="overview-empty">
                    <i class="el-icon-folder-opened"></i>
                    <p>暂无考勤项目</p>
                    <el-button type="text" @click="activeTab = 'item'">去「考勤项目」新增</el-button>
                  </div>
                  <div v-else-if="!filteredOverviewItems.length" class="overview-empty">
                    <p>当前筛选下没有项目</p>
                  </div>
                  <div v-else class="overview-scroll">
                    <div class="overview-card-grid">
                      <div
                        v-for="item in pagedOverviewItems"
                        :key="item.Id"
                        :class="['ov-card', { 'is-empty': !(item.Schedules && item.Schedules.length), 'is-off': !item.IsEnabled }]">
                        <div class="ov-card-head">
                          <div class="ov-card-title-wrap">
                            <div class="ov-card-title" :title="item.ItemName">{{ item.ItemName }}</div>
                            <el-tag :type="item.IsEnabled ? 'success' : 'info'" size="mini" effect="plain">
                              {{ item.IsEnabled ? '启用' : '停用' }}
                            </el-tag>
                          </div>
                          <div class="ov-card-meta">
                            每周应打 <b>{{ item.WeeklyRequiredCount }}</b> 次
                            <span class="overview-dot">·</span>
                            时段 <b>{{ (item.Schedules || []).length }}</b>
                          </div>
                        </div>

                        <div v-if="item.Schedules && item.Schedules.length" class="ov-card-body">
                          <div
                            v-for="sch in previewSchedules(item)"
                            :key="sch.Id"
                            class="ov-card-sch">
                            <div class="ov-card-sch-name">
                              <i class="el-icon-time"></i>
                              <span>{{ sch.ScheduleName }}</span>
                              <el-tag v-if="!sch.IsEnabled" type="info" size="mini" effect="plain">停用</el-tag>
                            </div>
                            <div class="ov-card-sch-chips">
                              <span class="ov-chip">{{ formatDate(sch.EffectiveStartDate) }} ~ {{ formatDate(sch.EffectiveEndDate) }}</span>
                              <span
                                v-for="(g, gi) in splitWeekTimeSummary(sch.WeekTimeSummary)"
                                :key="'og'+sch.Id+gi"
                                class="ov-chip ov-chip--time">{{ g }}</span>
                            </div>
                          </div>
                          <div v-if="(item.Schedules || []).length > 2" class="ov-card-more">
                            还有 {{ (item.Schedules || []).length - 2 }} 个时段…
                          </div>
                        </div>
                        <div v-else class="ov-card-empty">
                          尚未配置时段
                        </div>

                        <div class="ov-card-foot">
                          <el-button type="text" size="mini" @click="goItemSchedules(item)">去配置时段</el-button>
                          <el-button type="text" size="mini" @click="editOverviewItem(item)">编辑项目</el-button>
                        </div>
                      </div>
                    </div>
                    <div class="pagination-wrap" v-if="filteredOverviewItems.length > overviewPageSize">
                      <el-pagination
                        small
                        layout="total, prev, pager, next"
                        :current-page.sync="overviewPage"
                        :page-size="overviewPageSize"
                        :total="filteredOverviewItems.length">
                      </el-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="考勤项目" name="item">
            <div class="tab-scroll-panel">
            <div class="panel-toolbar">
              <div class="panel-toolbar-text">
                <span class="panel-title">考勤项目</span>
                <span class="panel-sub">如晚自习巡查、宿舍查寝等；可配置每周应打与拍照要求</span>
              </div>
              <el-button type="primary" size="small" icon="el-icon-plus" @click="openItemDialog()">新增项目</el-button>
            </div>
            <el-table :data="pagedItems" v-loading="itemLoading" stripe border class="htwa-table" empty-text="暂无项目，请先新增">
              <el-table-column prop="ItemName" label="项目名称" min-width="140" align="center"></el-table-column>
              <el-table-column label="项目说明" min-width="170" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.ItemDesc || "—" }}
                </template>
              </el-table-column>
              <el-table-column label="参与对象" min-width="130" align="center">
                <template slot-scope="scope">
                  <el-tag size="mini" effect="plain">{{ participantTypeText(scope.row.ParticipantType) }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="考核方式" min-width="110" align="center">
                <template slot-scope="scope">
                  {{ assessmentModeText(scope.row.AssessmentMode) }}
                </template>
              </el-table-column>
              <el-table-column prop="WeeklyRequiredCount" label="每周应打" min-width="110" align="center"></el-table-column>
              <el-table-column label="拍照" min-width="100" align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.RequirePhoto ? 'success' : 'info'" size="mini" effect="plain">
                    {{ scope.row.RequirePhoto ? '是' : '否' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="定位" min-width="100" align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.RequireLocation ? 'warning' : 'info'" size="mini" effect="plain">
                    {{ scope.row.RequireLocation ? '是' : '否' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="SortNo" label="排序" min-width="90" align="center"></el-table-column>
              <el-table-column label="状态" min-width="100" align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.IsEnabled ? 'success' : 'info'" size="mini">
                    {{ scope.row.IsEnabled ? '启用' : '停用' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="190" align="center">
                <template slot-scope="scope">
                  <div class="table-op-pair">
                    <el-button type="text" class="table-op-link" @click="openItemDialog(scope.row)">编辑</el-button>
                    <el-button type="text" class="table-op-link link-cyan" @click="selectItemForSchedule(scope.row)">配置时段</el-button>
                    <el-button
                      v-if="!scope.row.IsEnabled"
                      type="text"
                      class="table-op-link link-cyan"
                      @click="enableItem(scope.row)">启用</el-button>
                    <el-button type="text" class="table-op-link table-op-link--danger link-danger" @click="deleteItem(scope.row)">删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-wrap">
              <el-pagination
                layout="total, sizes, prev, pager, next"
                :current-page.sync="itemPage"
                :page-size.sync="itemPageSize"
                :page-sizes="[10, 20, 50]"
                :total="itemTotal"
                @size-change="onItemPageSizeChange"
                @current-change="onItemPageChange">
              </el-pagination>
            </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="考勤时段" name="schedule">
            <div class="tab-scroll-panel">
            <div class="panel-toolbar">
              <div class="panel-toolbar-text">
                <span class="panel-title">考勤时段</span>
                <span class="panel-sub">一条时段内可按周次配置每天时间；冬夏令仍可用多条日期范围</span>
              </div>
              <div class="panel-toolbar-actions">
                <el-select v-model="currentItemId" placeholder="请选择项目" clearable filterable class="item-select" @change="schedulePage = 1; loadSchedules()">
                  <el-option v-for="item in itemOptions" :key="item.Id" :label="item.ItemName" :value="item.Id"></el-option>
                </el-select>
                <el-button size="small" icon="el-icon-document" @click="openScheduleExcelDialog()">Excel 导入导出</el-button>
                <el-button type="primary" size="small" icon="el-icon-plus" :disabled="!currentItemId" @click="openScheduleDialog()">新增时段</el-button>
              </div>
            </div>
            <el-table :data="pagedSchedules" v-loading="scheduleLoading" stripe border class="htwa-table" empty-text="请选择项目后查看或新增时段">
              <el-table-column prop="ScheduleName" label="时段名称" min-width="120" align="center"></el-table-column>
              <el-table-column label="生效日期" min-width="180" align="center">
                <template slot-scope="scope">
                  {{ formatDate(scope.row.EffectiveStartDate) }} ~ {{ formatDate(scope.row.EffectiveEndDate) }}
                </template>
              </el-table-column>
              <el-table-column label="周次时间" min-width="220" align="center">
                <template slot-scope="scope">
                  <div class="week-time-cell">
                    <span
                      v-for="(g, gi) in weekTimeGroups(scope.row)"
                      :key="'wt'+gi"
                      class="week-time-chip">{{ g }}</span>
                    <span v-if="!weekTimeGroups(scope.row).length" class="week-time-empty">—</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="SortNo" label="排序" min-width="90" align="center"></el-table-column>
              <el-table-column label="状态" min-width="100" align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.IsEnabled ? 'success' : 'info'" size="mini">
                    {{ scope.row.IsEnabled ? '启用' : '停用' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="150" align="center">
                <template slot-scope="scope">
                  <div class="table-op-pair">
                    <el-button type="text" class="table-op-link" @click="openScheduleDialog(scope.row)">编辑</el-button>
                    <el-button
                      v-if="!scope.row.IsEnabled"
                      type="text"
                      class="table-op-link link-cyan"
                      @click="enableSchedule(scope.row)">启用</el-button>
                    <el-button type="text" class="table-op-link table-op-link--danger link-danger" @click="deleteSchedule(scope.row)">删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-wrap">
              <el-pagination
                layout="total, sizes, prev, pager, next"
                :current-page.sync="schedulePage"
                :page-size.sync="schedulePageSize"
                :page-sizes="[10, 20, 50]"
                :total="scheduleTotal"
                @size-change="onSchedulePageSizeChange"
                @current-change="onSchedulePageChange">
              </el-pagination>
            </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="统计管理员" name="admin">
            <div class="tab-scroll-panel">
              <div class="panel-toolbar">
                <div class="panel-toolbar-text">
                  <span class="panel-title">统计管理员</span>
                  <span class="panel-sub">管理员可在 H5 查看全校按日、按周统计</span>
                </div>
                <div class="panel-toolbar-actions">
                  <el-button type="primary" size="small" icon="el-icon-plus" @click="adminPickerVisible = true">添加管理员</el-button>
                </div>
              </div>
              <el-table :data="admins" v-loading="adminLoading" stripe border class="htwa-table">
                <el-table-column prop="Name" label="姓名" min-width="140"></el-table-column>
                <el-table-column prop="Remark" label="备注" min-width="180"></el-table-column>
                <el-table-column label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" class="table-op-link link-danger" @click="removeAdmin(scope.row)">移除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="pagination-wrap">
                <el-pagination
                  layout="total, sizes, prev, pager, next"
                  :current-page.sync="adminPage"
                  :page-size.sync="adminPageSize"
                  :page-sizes="[10, 20, 50]"
                  :total="adminTotal"
                  @size-change="loadAdmins"
                  @current-change="loadAdmins">
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <person-scope-picker-dialog
        :visible.sync="adminPickerVisible"
        directory-scope="internal"
        :show-scope-tabs="false"
        :scope-department-id="schoolId"
        multiple
        :close-on-confirm="false"
        :selected-people="[]"
        title="选择统计管理员"
        @confirm="onAdminTeacherPicked"
      />

      <person-scope-picker-dialog
        :visible.sync="itemStaffPickerVisible"
        directory-scope="internal"
        :show-scope-tabs="false"
        :scope-department-id="schoolId"
        multiple
        :selected-people="staffPickerSeed"
        :title="itemForm.ParticipantType === 3 ? '选择参与人员' : '选择排除人员'"
        @confirm="onItemStaffPicked"
      />

      <el-dialog :title="itemDialogTitle" :visible.sync="itemDialogVisible" width="760px" :close-on-click-modal="false" append-to-body custom-class="htwa-dialog">
        <el-form :model="itemForm" label-width="110px" ref="itemForm" size="small" class="item-config-form">
          <el-row :gutter="18">
            <el-col :span="24">
              <el-form-item label="项目名称" required>
                <el-input v-model="itemForm.ItemName" maxlength="100"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="项目说明">
                <el-input v-model="itemForm.ItemDesc" type="textarea" :rows="2" maxlength="500"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="参与对象">
                <el-radio-group v-model="itemForm.ParticipantType">
                  <el-radio :label="1">仅班主任</el-radio>
                  <el-radio :label="2">全体任教教师</el-radio>
                  <el-radio :label="3">自定义教职工</el-radio>
                </el-radio-group>
                <div class="field-hint">全体任教教师包含班主任；个人签到项目按人统计。</div>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="itemForm.ParticipantType === 2 || itemForm.ParticipantType === 3">
              <el-form-item :label="itemForm.ParticipantType === 3 ? '参与人员' : '排除人员'" :required="itemForm.ParticipantType === 3">
                <div class="staff-picker-box" v-loading="itemStaffLoading">
                  <div class="staff-picker-head">
                    <span v-if="currentStaffList.length" class="staff-picker-count">
                      已选 <b>{{ currentStaffList.length }}</b> 人
                    </span>
                    <span v-else class="staff-picker-empty">
                      {{ itemForm.ParticipantType === 3 ? "请选择参与签到的教职工" : "不排除，全体任教教师均参与" }}
                    </span>
                    <div class="staff-picker-actions">
                      <el-button size="mini" type="primary" plain icon="el-icon-plus" @click="itemStaffPickerVisible = true">选择教职工</el-button>
                      <el-button v-if="currentStaffList.length" size="mini" @click="clearCurrentStaff">清空</el-button>
                    </div>
                  </div>
                  <div v-if="currentStaffList.length" class="staff-picker-tags">
                    <el-tag
                      v-for="p in currentStaffList"
                      :key="p.TeacherMasterId"
                      size="small"
                      closable
                      @close="removeStaff(p)">{{ p.TeacherName || p.TeacherMasterId }}</el-tag>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="考核方式">
                <el-radio-group v-model="itemForm.AssessmentMode">
                  <el-radio :label="1">每周达标</el-radio>
                  <el-radio :label="2">每场必到</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="每周应打">
                <el-input-number v-model="itemForm.WeeklyRequiredCount" :min="0" :max="99" :disabled="itemForm.AssessmentMode === 2"></el-input-number>
                <div class="field-hint">0 表示只记录</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="必须拍照">
                <el-switch v-model="itemForm.RequirePhoto"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最少照片数" v-if="itemForm.RequirePhoto">
                <el-input-number v-model="itemForm.MinPhotoCount" :min="1" :max="9"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="拍照要求">
                <el-input v-model="itemForm.PhotoRequireDesc" maxlength="500" placeholder="如：宿舍内学生照片"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="现场拍摄">
                <el-switch v-model="itemForm.RequireLivePhoto"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="必须定位">
                <el-switch v-model="itemForm.RequireLocation"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="地点说明">
                <el-input v-model="itemForm.LocationDesc" maxlength="500" placeholder="如：操场 / 本班教室"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="补卡覆盖">
                <el-select v-model="itemForm.AllowMakeup" clearable placeholder="继承方案" style="width: 100%;">
                  <el-option label="继承方案" :value="null"></el-option>
                  <el-option label="允许" :value="true"></el-option>
                  <el-option label="不允许" :value="false"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="itemForm.AllowMakeup === true">
              <el-form-item label="项目补卡天数">
                <el-input-number v-model="itemForm.MakeupDays" :min="1" :max="60"></el-input-number>
                <div class="field-hint">该项目单独允许补卡时生效</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="排序">
                <el-input-number v-model="itemForm.SortNo" :min="0" :max="9999"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="启用">
                <el-switch v-model="itemForm.IsEnabled"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer">
          <el-button @click="itemDialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="itemSaving" @click="saveItem">确定</el-button>
        </div>
      </el-dialog>

      <el-dialog :title="scheduleDialogTitle" :visible.sync="scheduleDialogVisible" width="680px" :close-on-click-modal="false" append-to-body custom-class="htwa-dialog sch-dialog">
        <div v-if="currentItemName" class="sch-item-banner">
          <i class="el-icon-collection-tag"></i>
          所属项目：<b>{{ currentItemName }}</b>
        </div>
        <el-form :model="scheduleForm" label-position="top" size="small" class="sch-form">
          <!-- 基本信息 -->
          <section class="sch-section">
            <div class="sch-section-title"><span class="sch-title-text">基本信息</span></div>
            <div class="sch-grid">
              <el-form-item label="时段名称" required class="sch-col-name">
                <el-input v-model="scheduleForm.ScheduleName" maxlength="100" placeholder="请输入时段名称"></el-input>
              </el-form-item>
              <el-form-item label="生效日期" required class="sch-col-date">
                <el-date-picker
                  v-model="scheduleForm.dateRange"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 100%;">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="排序" class="sch-col-name">
                <el-input-number v-model="scheduleForm.SortNo" :min="0" :max="9999" controls-position="right" style="width: 140px;"></el-input-number>
              </el-form-item>
              <el-form-item label="状态" class="sch-col-date">
                <el-switch v-model="scheduleForm.IsEnabled" active-text="启用" inactive-text="停用"></el-switch>
              </el-form-item>
            </div>
          </section>

          <!-- 打卡安排：星期 + 时间 -->
          <section class="sch-section">
            <div class="sch-section-title"><span class="sch-title-text">打卡安排</span></div>

            <div class="sch-field-head">
              <span class="sch-field-label"><i class="sch-required">*</i>打卡星期</span>
              <span class="sch-quick">
                <a @click="setUsingWeekDays(['1','2','3','4','5'])">工作日</a>
                <a @click="setUsingWeekDays(['1','2','3','4','5','6','7'])">每天</a>
                <a @click="setUsingWeekDays([])">清空</a>
              </span>
            </div>
            <div class="sch-week-pills" role="group" aria-label="打卡星期">
              <button
                v-for="d in weekOptions"
                :key="d.value"
                type="button"
                class="sch-pill"
                :class="{ 'is-on': isWeekDayOn(d.value) }"
                :aria-pressed="isWeekDayOn(d.value) ? 'true' : 'false'"
                @click="toggleWeekDay(d.value)">
                周{{ d.label }}
              </button>
            </div>

            <div class="sch-field-head">
              <span class="sch-field-label"><i class="sch-required">*</i>打卡时间</span>
              <div class="sch-mode-seg" role="tablist">
                <button type="button" class="sch-mode-item" :class="{ 'is-active': scheduleForm.unifyTime }" @click="setUnifyMode(true)">每天相同</button>
                <button type="button" class="sch-mode-item" :class="{ 'is-active': !scheduleForm.unifyTime }" @click="setUnifyMode(false)">部分星期不同</button>
              </div>
            </div>
            <div class="sch-time-line">
              <el-time-picker v-model="scheduleForm.unifyStart" value-format="HH:mm:ss" format="HH:mm" placeholder="开始时间" class="sch-time-picker"></el-time-picker>
              <span class="sch-time-sep">至</span>
              <el-time-picker v-model="scheduleForm.unifyEnd" value-format="HH:mm:ss" format="HH:mm" placeholder="结束时间" class="sch-time-picker"></el-time-picker>
              <span v-if="!scheduleForm.unifyTime" class="sch-time-tip">未单独设置的星期使用此时间</span>
            </div>

            <div v-if="!scheduleForm.unifyTime" class="sch-custom-box">
              <div class="sch-custom-head">
                <span>选择需要单独设置时间的星期：</span>
                <span v-if="!enabledWeekOptions.length" class="sch-time-tip">请先选择打卡星期</span>
                <button
                  v-for="d in enabledWeekOptions"
                  :key="'cc' + d.value"
                  type="button"
                  class="sch-mini-chip"
                  :class="{ 'is-on': isCustomDay(d.value) }"
                  @click="toggleCustomDay(d.value)">
                  周{{ d.label }}
                </button>
              </div>
              <div
                v-for="d in customEnabledWeekOptions"
                :key="'row' + d.value"
                class="sch-custom-row">
                <span class="sch-custom-day">周{{ d.label }}</span>
                <el-time-picker v-model="dayDetailOf(d.value).StartTime" value-format="HH:mm:ss" format="HH:mm" class="sch-time-picker"></el-time-picker>
                <span class="sch-time-sep">至</span>
                <el-time-picker v-model="dayDetailOf(d.value).EndTime" value-format="HH:mm:ss" format="HH:mm" class="sch-time-picker"></el-time-picker>
                <i class="el-icon-close sch-custom-remove" title="恢复默认时间" @click="toggleCustomDay(d.value)"></i>
              </div>
            </div>

            <div class="sch-preview" :class="{ 'is-empty': !schedulePreviewLines.length }">
              <span class="sch-preview-label">打卡安排预览</span>
              <div v-if="schedulePreviewLines.length" class="sch-preview-lines">
                <span v-for="(line, i) in schedulePreviewLines" :key="'pv' + i" class="sch-preview-chip">{{ line }}</span>
              </div>
              <span v-else class="sch-time-tip">请选择打卡星期和时间</span>
            </div>
          </section>
        </el-form>

        <div slot="footer">
          <el-button @click="scheduleDialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="scheduleSaving" @click="saveSchedule">确定</el-button>
        </div>
      </el-dialog>

      <el-dialog
        :visible.sync="scheduleExcelVisible"
        width="860px"
        :close-on-click-modal="false"
        append-to-body
        custom-class="htwa-excel-dialog"
        @close="onScheduleExcelDialogClose">
        <div slot="title" class="excel-dialog-head">
          <span class="excel-dialog-icon"><i class="el-icon-tickets"></i></span>
          <div class="excel-dialog-head-text">
            <div class="excel-dialog-title">时段 Excel</div>
            <div class="excel-dialog-sub">下载模板 · 导出配置 · 批量导入</div>
          </div>
        </div>

        <div class="excel-seg" role="tablist">
          <button
            type="button"
            class="excel-seg-item"
            :class="{ 'is-active': scheduleExcelTab === 'template' }"
            @click="scheduleExcelTab = 'template'">
            <i class="el-icon-download"></i>
            <span>下载模板</span>
          </button>
          <button
            type="button"
            class="excel-seg-item"
            :class="{ 'is-active': scheduleExcelTab === 'export' }"
            @click="scheduleExcelTab = 'export'">
            <i class="el-icon-document"></i>
            <span>导出配置</span>
          </button>
          <button
            type="button"
            class="excel-seg-item"
            :class="{ 'is-active': scheduleExcelTab === 'import' }"
            @click="scheduleExcelTab = 'import'">
            <i class="el-icon-upload2"></i>
            <span>导入</span>
          </button>
        </div>

        <div v-show="scheduleExcelTab === 'template'" class="excel-panel">
          <div class="excel-hero-card">
            <div class="excel-hero-copy">
              <h4>先下载模板再填写</h4>
              <p>含「填写说明」与示例行。填好后切到「导入」上传即可。</p>
            </div>
            <el-button
              type="primary"
              size="medium"
              class="excel-cta"
              icon="el-icon-download"
              :loading="templateDownloading"
              @click="downloadScheduleTemplate">
              下载导入模板
            </el-button>
          </div>
          <div class="excel-rule-grid">
            <div class="excel-rule">
              <div class="excel-rule-k">启用星期</div>
              <div class="excel-rule-v">1=周一…7=周日，如 <code>1|2|3|4|5</code></div>
            </div>
            <div class="excel-rule">
              <div class="excel-rule-k">独立时间</div>
              <div class="excel-rule-v">仅写不同天，如 <code>5:08:30-09:30</code></div>
            </div>
            <div class="excel-rule">
              <div class="excel-rule-k">更新规则</div>
              <div class="excel-rule-v">同项目+时段+生效起止则更新，否则新增</div>
            </div>
          </div>
        </div>

        <div v-show="scheduleExcelTab === 'export'" class="excel-panel">
          <div class="excel-hero-card">
            <div class="excel-hero-copy">
              <h4>导出后可改再导入</h4>
              <p>导出当前学校时段配置。左侧已选项目时，只导出该项目。</p>
            </div>
            <el-button
              type="primary"
              size="medium"
              class="excel-cta"
              icon="el-icon-document"
              :loading="scheduleExporting"
              @click="exportSchedules">
              导出当前配置
            </el-button>
          </div>
          <div class="excel-scope-chip">
            <i class="el-icon-folder-opened"></i>
            <span>导出范围：{{ currentItemId ? ('当前项目「' + currentItemName + '」') : '全校全部项目' }}</span>
          </div>
        </div>

        <div v-show="scheduleExcelTab === 'import'" class="excel-panel excel-panel--import">
          <div class="excel-steps">
            <div
              class="excel-step"
              :class="{ 'is-active': scheduleImportStep === 'upload', 'is-done': scheduleImportStep !== 'upload' }">
              <span class="excel-step-no">1</span>
              <span class="excel-step-label">选择文件</span>
            </div>
            <div class="excel-step-line" :class="{ 'is-on': scheduleImportStep !== 'upload' }"></div>
            <div
              class="excel-step"
              :class="{
                'is-active': scheduleImportStep === 'preview',
                'is-done': scheduleImportStep === 'result'
              }">
              <span class="excel-step-no">2</span>
              <span class="excel-step-label">预览调整</span>
            </div>
            <div class="excel-step-line" :class="{ 'is-on': scheduleImportStep === 'result' }"></div>
            <div class="excel-step" :class="{ 'is-active': scheduleImportStep === 'result' }">
              <span class="excel-step-no">3</span>
              <span class="excel-step-label">导入结果</span>
            </div>
          </div>

          <div v-show="scheduleImportStep === 'upload'" class="excel-upload-layout">
            <el-upload
              ref="scheduleImportUpload"
              class="excel-uploader"
              drag
              action=""
              :auto-upload="false"
              :limit="1"
              accept=".xlsx,.xls"
              :on-change="onScheduleImportFileChange"
              :on-remove="onScheduleImportFileRemove"
              :file-list="scheduleImportFile ? [{ name: scheduleImportFile.name }] : []">
              <i class="el-icon-upload excel-uploader-icon"></i>
              <div class="el-upload__text">将 Excel 拖到此处，或 <em>点击选择</em></div>
              <div class="excel-uploader-hint">支持 .xlsx / .xls</div>
            </el-upload>
            <div class="excel-upload-side">
              <div class="excel-side-title">上传前建议</div>
              <ol class="excel-side-list">
                <li>先「下载模板」或「导出配置」</li>
                <li>按表头填写，勿改列名</li>
                <li>选文件后进入预览，可再改再导</li>
              </ol>
            </div>
          </div>
          <div v-if="scheduleImportStep === 'upload' && scheduleImportParseErrors.length" class="import-errors">
            <div>解析告警：</div>
            <ul>
              <li v-for="(err, idx) in scheduleImportParseErrors" :key="'pe'+idx">{{ err }}</li>
            </ul>
          </div>

          <div v-show="scheduleImportStep === 'preview'">
            <div class="excel-preview-bar">
              <span>共 <b>{{ scheduleImportRows.length }}</b> 行 · 默认折叠，点「修改」展开编辑</span>
              <el-button
                v-if="scheduleImportExpandedIndex != null"
                type="text"
                size="mini"
                @click="scheduleImportExpandedIndex = null">全部收起</el-button>
            </div>
            <div class="excel-preview-list">
              <div
                v-for="(row, index) in scheduleImportRows"
                :key="'imp-' + row.RowNo + '-' + index"
                :class="['excel-preview-item', { 'is-open': scheduleImportExpandedIndex === index }]">
                <div class="excel-preview-summary" @click="toggleImportRowExpand(index)">
                  <span class="excel-preview-rowno">#{{ row.RowNo }}</span>
                  <div class="excel-preview-summary-main">
                    <span class="excel-preview-title">{{ row.ItemName || '（未填项目）' }}</span>
                    <span class="excel-preview-sep">·</span>
                    <span class="excel-preview-sub">{{ row.ScheduleName || '（未填时段）' }}</span>
                  </div>
                  <span class="excel-preview-meta" :title="(row.EffectiveStartDate || '') + ' ~ ' + (row.EffectiveEndDate || '')">
                    {{ row.EffectiveStartDate || '—' }} ~ {{ row.EffectiveEndDate || '—' }}
                  </span>
                  <span class="excel-preview-time">
                    {{ formatTime(row.UnifyStartTime) || '—' }}-{{ formatTime(row.UnifyEndTime) || '—' }}
                  </span>
                  <el-tag :type="row.IsEnabled ? 'success' : 'info'" size="mini" effect="plain">
                    {{ row.IsEnabled ? '启用' : '停用' }}
                  </el-tag>
                  <div class="excel-preview-summary-actions" @click.stop>
                    <el-button type="text" size="mini" @click="toggleImportRowExpand(index)">
                      {{ scheduleImportExpandedIndex === index ? '收起' : '修改' }}
                    </el-button>
                    <el-button type="text" size="mini" class="link-danger" @click="removeScheduleImportRow(index)">删除</el-button>
                  </div>
                </div>
                <div v-show="scheduleImportExpandedIndex === index" class="excel-preview-editor">
                  <div class="excel-preview-grid">
                    <div class="ep-field ep-field--2">
                      <label>项目名称</label>
                      <el-input v-model="row.ItemName" size="mini"></el-input>
                    </div>
                    <div class="ep-field ep-field--2">
                      <label>时段名称</label>
                      <el-input v-model="row.ScheduleName" size="mini"></el-input>
                    </div>
                    <div class="ep-field">
                      <label>生效开始</label>
                      <el-date-picker
                        v-model="row.EffectiveStartDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        size="mini"
                        style="width: 100%;">
                      </el-date-picker>
                    </div>
                    <div class="ep-field">
                      <label>生效结束</label>
                      <el-date-picker
                        v-model="row.EffectiveEndDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        size="mini"
                        style="width: 100%;">
                      </el-date-picker>
                    </div>
                    <div class="ep-field">
                      <label>启用星期</label>
                      <el-input v-model="row.UsingWeekDays" size="mini" placeholder="1|2|3|4|5"></el-input>
                    </div>
                    <div class="ep-field">
                      <label>排序</label>
                      <el-input-number v-model="row.SortNo" size="mini" :controls="false" style="width: 100%;"></el-input-number>
                    </div>
                    <div class="ep-field">
                      <label>统一开始</label>
                      <el-input v-model="row.UnifyStartTime" size="mini" placeholder="09:00:00"></el-input>
                    </div>
                    <div class="ep-field">
                      <label>统一结束</label>
                      <el-input v-model="row.UnifyEndTime" size="mini" placeholder="10:00:00"></el-input>
                    </div>
                    <div class="ep-field ep-field--3">
                      <label>独立时间</label>
                      <el-input v-model="row.CustomDayTimes" size="mini" placeholder="5:08:30-09:30；仅填与统一不同的天"></el-input>
                    </div>
                    <div class="ep-field">
                      <label>启用</label>
                      <div class="ep-switch-wrap">
                        <el-switch v-model="row.IsEnabled" active-text="启用" inactive-text="停用"></el-switch>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-show="scheduleImportStep === 'result'">
            <div class="excel-result-cards">
              <div class="excel-result-card excel-result-card--ok">
                <div class="excel-result-num">{{ scheduleImportSuccessCount }}</div>
                <div class="excel-result-label">成功</div>
              </div>
              <div class="excel-result-card excel-result-card--fail">
                <div class="excel-result-num">{{ scheduleImportFailCount }}</div>
                <div class="excel-result-label">失败</div>
              </div>
            </div>
            <el-table :data="scheduleImportDetails" border size="mini" max-height="280">
              <el-table-column label="行" width="60" align="center" prop="RowNo"></el-table-column>
              <el-table-column label="项目" min-width="120" prop="ItemName" show-overflow-tooltip></el-table-column>
              <el-table-column label="时段" min-width="100" prop="ScheduleName" show-overflow-tooltip></el-table-column>
              <el-table-column label="结果" width="90" align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.Success ? 'success' : 'danger'" size="mini">
                    {{ scope.row.Success ? (scope.row.IsUpdate ? '已更新' : '已新增') : '失败' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="说明" min-width="220" prop="Message" show-overflow-tooltip></el-table-column>
            </el-table>
          </div>
        </div>

        <div slot="footer" class="excel-dialog-footer">
          <template v-if="scheduleExcelTab === 'import'">
            <el-button v-if="scheduleImportStep === 'preview'" @click="backToUploadStep">重新选文件</el-button>
            <el-button v-if="scheduleImportStep === 'result'" @click="backToUploadStep">继续导入</el-button>
          </template>
          <el-button @click="scheduleExcelVisible = false">关闭</el-button>
          <el-button
            v-if="scheduleExcelTab === 'import' && scheduleImportStep === 'upload'"
            type="primary"
            :loading="schedulePreviewLoading"
            @click="previewScheduleImport">解析预览</el-button>
          <el-button
            v-if="scheduleExcelTab === 'import' && scheduleImportStep === 'preview'"
            type="primary"
            :loading="scheduleImporting"
            :disabled="!scheduleImportRows.length"
            @click="submitScheduleImport">确认导入</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import DepartmentPane from "../../components/DepartmentPane";
import PersonScopePickerDialog from "../../components/PersonScopePickerDialog";
import {
  getHeadTeacherWorkAttendancePlan,
  saveHeadTeacherWorkAttendancePlan,
  getHeadTeacherWorkAttendanceItems,
  getHeadTeacherWorkAttendanceConfigOverview,
  saveHeadTeacherWorkAttendanceItem,
  getHeadTeacherWorkAttendanceItemStaff,
  saveHeadTeacherWorkAttendanceItemStaff,
  disableHeadTeacherWorkAttendanceItem,
  getHeadTeacherWorkAttendanceSchedules,
  saveHeadTeacherWorkAttendanceSchedule,
  disableHeadTeacherWorkAttendanceSchedule,
  downloadHeadTeacherWorkAttendanceScheduleTemplate,
  exportHeadTeacherWorkAttendanceSchedules,
  previewHeadTeacherWorkAttendanceScheduleImport,
  importHeadTeacherWorkAttendanceSchedulesByRows,
  downloadHeadTeacherWorkAttendanceBlob,
  resolveHeadTeacherWorkAttendanceSchoolIdFromTreeNode,
  onHeadTeacherWorkAttendanceSchoolChange,
  getHeadTeacherWorkAttendanceAdmins,
  saveHeadTeacherWorkAttendanceAdmin,
  deleteHeadTeacherWorkAttendanceAdmin
} from "@/api/headTeacherWorkAttendance";

const schoolLikeTypes = ["school", "campus", "affiliateschool"];

/** 从树节点解析学校展示名 */
function pickSchoolDisplayName(node, data) {
  let n = node;
  while (n && n.data) {
    const t = String(n.data.DeptOrgType != null ? n.data.DeptOrgType : n.data.deptOrgType || "").toLowerCase();
    if (schoolLikeTypes.includes(t)) {
      return n.data.label || n.data.name || "";
    }
    n = n.parent;
  }
  return (data && (data.label || data.name)) || "";
}

export default {
  components: { DepartmentPane, PersonScopePickerDialog },
  data() {
    return {
      activeTab: "plan",
      schoolId: 0,
      DepartmentId: 0,
      currentSchoolName: "",
      pageLoading: false,
      planLoading: false,
      planSaving: false,
      planForm: {
        PlanName: "教职工工作考勤",
        IsEnabled: true,
        AllowMakeup: false,
        MakeupDays: 0
      },
      overviewLoading: false,
      overviewFilter: "all",
      overviewPage: 1,
      overviewPageSize: 6,
      configOverview: {
        ItemCount: 0,
        EnabledItemCount: 0,
        ScheduleCount: 0,
        EnabledScheduleCount: 0,
        Items: []
      },
      items: [],
      itemTotal: 0,
      itemPage: 1,
      itemPageSize: 10,
      itemLoading: false,
      itemSaving: false,
      itemDialogVisible: false,
      itemDialogTitle: "新增项目",
      itemForm: this.createEmptyItem(),
      currentItemId: null,
      schedules: [],
      scheduleTotal: 0,
      schedulePage: 1,
      schedulePageSize: 10,
      scheduleLoading: false,
      scheduleSaving: false,
      scheduleDialogVisible: false,
      scheduleDialogTitle: "新增时段",
      scheduleForm: this.createEmptySchedule(),
      admins: [],
      adminTotal: 0,
      adminPage: 1,
      adminPageSize: 10,
      adminLoading: false,
      adminPickerVisible: false,
      itemStaffPickerVisible: false,
      itemStaffLoading: false,
      // 自定义教职工：参与名单（IncludeType=1）；全体任教教师：排除名单（IncludeType=2）
      itemIncludeStaff: [],
      itemExcludeStaff: [],
      templateDownloading: false,
      scheduleExporting: false,
      scheduleExcelVisible: false,
      scheduleExcelTab: "template",
      scheduleImporting: false,
      schedulePreviewLoading: false,
      scheduleImportStep: "upload",
      scheduleImportFile: null,
      scheduleImportRows: [],
      scheduleImportExpandedIndex: null,
      scheduleImportParseErrors: [],
      scheduleImportDetails: [],
      scheduleImportSuccessCount: 0,
      scheduleImportFailCount: 0,
      weekOptions: [
        { value: "1", label: "一" },
        { value: "2", label: "二" },
        { value: "3", label: "三" },
        { value: "4", label: "四" },
        { value: "5", label: "五" },
        { value: "6", label: "六" },
        { value: "7", label: "日" }
      ]
    };
  },
  computed: {
    /** 当前参与对象对应的名单：自定义=参与人员，全体任教=排除人员 */
    currentStaffList() {
      return this.itemForm.ParticipantType === 3 ? this.itemIncludeStaff : this.itemExcludeStaff;
    },
    staffPickerSeed() {
      return this.currentStaffList.map(x => ({ id: x.TeacherMasterId, name: x.TeacherName }));
    },
    currentItemName() {
      if (!this.currentItemId) return "";
      const hit = (this.items || []).find(x => (x.Id || x.id) === this.currentItemId);
      return hit ? (hit.ItemName || hit.itemName || "") : "";
    },
    filteredOverviewItems() {
      const list = this.configOverview.Items || [];
      if (this.overviewFilter === "ready") {
        return list.filter(x => (x.Schedules || []).length > 0);
      }
      if (this.overviewFilter === "empty") {
        return list.filter(x => !(x.Schedules || []).length);
      }
      return list;
    },
    pagedOverviewItems() {
      const list = this.filteredOverviewItems;
      const size = this.overviewPageSize || 6;
      const page = Math.max(1, this.overviewPage || 1);
      const start = (page - 1) * size;
      return list.slice(start, start + size);
    },
    pagedItems() {
      return this.items || [];
    },
    itemOptions() {
      return (this.configOverview && this.configOverview.Items) || this.items || [];
    },
    pagedSchedules() {
      return this.schedules || [];
    },
    enabledWeekOptions() {
      const enabled = new Set((this.scheduleForm.UsingWeekDays || []).map(String));
      return this.weekOptions.filter(d => enabled.has(String(d.value)));
    },
    customEnabledWeekOptions() {
      const custom = new Set((this.scheduleForm.customWeekDays || []).map(String));
      return this.enabledWeekOptions.filter(d => custom.has(String(d.value)));
    },
    /** 时段弹窗底部预览：按相同时间分组，如「周一、周二 07:20-07:40」。创建于 2026-10-04 */
    schedulePreviewLines() {
      if (!this.scheduleDialogVisible) return [];
      const days = this.buildDayDetailsForSave().filter(d => d.IsEnabled && d.StartTime && d.EndTime);
      const groups = [];
      const map = {};
      days.forEach(d => {
        const key = `${this.formatTime(d.StartTime)}-${this.formatTime(d.EndTime)}`;
        if (!map[key]) {
          map[key] = { key, days: [] };
          groups.push(map[key]);
        }
        map[key].days.push("\u5468" + this.weekDayLabel(d.WeekDay));
      });
      return groups.map(g => `${g.days.join("\u3001")} ${g.key}`);
    }
  },
  methods: {
    createEmptyItem() {
      return {
        Id: 0,
        ItemName: "",
        ItemDesc: "",
        SortNo: 0,
        IsEnabled: true,
        RequirePhoto: true,
        MinPhotoCount: 1,
        PhotoRequireDesc: "",
        RequireLivePhoto: false,
        RequireLocation: false,
        LocationDesc: "",
        AllowMakeup: null,
        MakeupDays: null,
        WeeklyRequiredCount: 2,
        ParticipantType: 1,
        AssessmentMode: 1
      };
    },
    createEmptyDayDetails(start, end, enabledSet) {
      const workDays = enabledSet || new Set([1, 2, 3, 4, 5]);
      const startTime = start || "09:00:00";
      const endTime = end || "10:00:00";
      return [1, 2, 3, 4, 5, 6, 7].map(d => ({
        WeekDay: d,
        IsEnabled: workDays.has(d) || workDays.has(String(d)),
        StartTime: startTime,
        EndTime: endTime
      }));
    },
    createEmptySchedule() {
      return {
        Id: 0,
        ScheduleName: "",
        dateRange: [],
        UsingWeekDays: ["1", "2", "3", "4", "5"],
        DayDetails: this.createEmptyDayDetails(),
        unifyStart: "09:00:00",
        unifyEnd: "10:00:00",
        unifyTime: true,
        customWeekDays: [],
        SortNo: 0,
        IsEnabled: true
      };
    },
    weekDayLabel(weekDay) {
      const map = { 1: "一", 2: "二", 3: "三", 4: "四", 5: "五", 6: "六", 7: "日" };
      return map[Number(weekDay)] || weekDay;
    },
    normalizeDayDetails(row) {
      const source = row.DayDetails || row.dayDetails || [];
      const map = {};
      (source || []).forEach(d => {
        const weekDay = Number(d.WeekDay != null ? d.WeekDay : d.weekDay);
        if (!weekDay) return;
        map[weekDay] = {
          WeekDay: weekDay,
          IsEnabled: !!(d.IsEnabled != null ? d.IsEnabled : d.isEnabled),
          StartTime: d.StartTime || d.startTime || "09:00:00",
          EndTime: d.EndTime || d.endTime || "10:00:00"
        };
      });
      if (Object.keys(map).length === 0) {
        const days = row.UsingWeekDays || row.usingWeekDays || String(row.UsingWeekDayStr || "").split("|");
        const enabled = new Set((days || []).map(String).filter(Boolean));
        const start = row.StartTime || row.startTime || "09:00:00";
        const end = row.EndTime || row.endTime || "10:00:00";
        return [1, 2, 3, 4, 5, 6, 7].map(d => ({
          WeekDay: d,
          IsEnabled: enabled.has(String(d)),
          StartTime: start,
          EndTime: end
        }));
      }
      return [1, 2, 3, 4, 5, 6, 7].map(d => map[d] || {
        WeekDay: d,
        IsEnabled: false,
        StartTime: "09:00:00",
        EndTime: "10:00:00"
      });
    },
    /** 从已有周次详情推断统一时间 / 独立周次 */
    resolveUnifyMode(dayDetails) {
      const enabled = (dayDetails || []).filter(d => d.IsEnabled);
      if (!enabled.length) {
        return { unifyTime: true, unifyStart: "09:00:00", unifyEnd: "10:00:00", customWeekDays: [] };
      }
      const groups = {};
      enabled.forEach(d => {
        const key = `${d.StartTime}|${d.EndTime}`;
        if (!groups[key]) groups[key] = [];
        groups[key].push(d.WeekDay);
      });
      const keys = Object.keys(groups);
      if (keys.length === 1) {
        const [start, end] = keys[0].split("|");
        return { unifyTime: true, unifyStart: start, unifyEnd: end, customWeekDays: [] };
      }
      // 取出现次数最多的时间作为统一时间，其余为独立
      let baseKey = keys[0];
      keys.forEach(k => {
        if (groups[k].length > groups[baseKey].length) baseKey = k;
      });
      const [unifyStart, unifyEnd] = baseKey.split("|");
      const customWeekDays = keys
        .filter(k => k !== baseKey)
        .reduce((arr, k) => arr.concat(groups[k]), [])
        .map(d => String(d))
        .sort((a, b) => Number(a) - Number(b));
      return { unifyTime: false, unifyStart, unifyEnd, customWeekDays };
    },
    onUsingWeekDaysChange(days) {
      const enabled = new Set((days || []).map(String));
      this.scheduleForm.customWeekDays = (this.scheduleForm.customWeekDays || [])
        .map(String)
        .filter(d => enabled.has(d));
      (this.scheduleForm.DayDetails || []).forEach(d => {
        d.IsEnabled = enabled.has(String(d.WeekDay));
      });
    },
    isWeekDayOn(value) {
      return (this.scheduleForm.UsingWeekDays || []).map(String).includes(String(value));
    },
    /** 胶囊按钮切换打卡星期，保持 1~7 顺序 */
    toggleWeekDay(value) {
      const key = String(value);
      const set = new Set((this.scheduleForm.UsingWeekDays || []).map(String));
      if (set.has(key)) set.delete(key);
      else set.add(key);
      this.setUsingWeekDays(Array.from(set));
    },
    setUsingWeekDays(days) {
      const sorted = (days || []).map(String).sort((a, b) => Number(a) - Number(b));
      this.scheduleForm.UsingWeekDays = sorted;
      this.onUsingWeekDaysChange(sorted);
    },
    setUnifyMode(val) {
      if (this.scheduleForm.unifyTime === val) return;
      this.scheduleForm.unifyTime = val;
      this.onUnifyTimeChange(val);
    },
    isCustomDay(value) {
      return (this.scheduleForm.customWeekDays || []).map(String).includes(String(value));
    },
    dayDetailOf(value) {
      const hit = (this.scheduleForm.DayDetails || []).find(d => String(d.WeekDay) === String(value));
      return hit || {};
    },
    /** 某天在「部分星期不同」模式下切换单独时间 / 跟随默认时间 */
    toggleCustomDay(value) {
      const key = String(value);
      if (!(this.scheduleForm.DayDetails || []).some(d => String(d.WeekDay) === key)) {
        if (!Array.isArray(this.scheduleForm.DayDetails)) this.$set(this.scheduleForm, "DayDetails", []);
        this.scheduleForm.DayDetails.push({ WeekDay: Number(key), IsEnabled: true, StartTime: "", EndTime: "" });
      }
      const set = new Set((this.scheduleForm.customWeekDays || []).map(String));
      if (set.has(key)) {
        set.delete(key);
      } else {
        set.add(key);
        const row = this.dayDetailOf(key);
        row.StartTime = this.scheduleForm.unifyStart || "09:00:00";
        row.EndTime = this.scheduleForm.unifyEnd || "10:00:00";
      }
      const days = Array.from(set).sort((a, b) => Number(a) - Number(b));
      this.scheduleForm.customWeekDays = days;
      this.onCustomWeekDaysChange(days);
    },
    onUnifyTimeChange(val) {
      if (val) {
        this.scheduleForm.customWeekDays = [];
      }
    },
    onCustomWeekDaysChange(days) {
      const start = this.scheduleForm.unifyStart || "09:00:00";
      const end = this.scheduleForm.unifyEnd || "10:00:00";
      const selected = new Set((days || []).map(String));
      (this.scheduleForm.DayDetails || []).forEach(d => {
        if (!selected.has(String(d.WeekDay))) return;
        if (!d.StartTime) d.StartTime = start;
        if (!d.EndTime) d.EndTime = end;
      });
    },
    buildDayDetailsForSave() {
      const enabled = new Set((this.scheduleForm.UsingWeekDays || []).map(String));
      const custom = new Set((this.scheduleForm.customWeekDays || []).map(String));
      const unifyStart = this.scheduleForm.unifyStart;
      const unifyEnd = this.scheduleForm.unifyEnd;
      const unifyMode = !!this.scheduleForm.unifyTime;
      const detailMap = {};
      (this.scheduleForm.DayDetails || []).forEach(d => {
        detailMap[String(d.WeekDay)] = d;
      });
      return [1, 2, 3, 4, 5, 6, 7].map(weekDay => {
        const key = String(weekDay);
        const row = detailMap[key] || { WeekDay: weekDay, StartTime: unifyStart, EndTime: unifyEnd };
        const isEnabled = enabled.has(key);
        const useCustom = !unifyMode && isEnabled && custom.has(key);
        return {
          WeekDay: weekDay,
          IsEnabled: isEnabled,
          StartTime: useCustom ? row.StartTime : unifyStart,
          EndTime: useCustom ? row.EndTime : unifyEnd
        };
      });
    },
    formatDate(val) {
      return val ? String(val).substring(0, 10) : "";
    },
    participantTypeText(value) {
      return {
        1: "仅班主任",
        2: "全体任教教师",
        3: "自定义教职工"
      }[Number(value)] || "—";
    },
    assessmentModeText(value) {
      return Number(value) === 2 ? "每场必到" : "每周达标次数";
    },
    formatTime(val) {
      return val ? String(val).substring(0, 5) : "";
    },
    formatWeekDays(days) {
      // 用 Unicode 转义，避免文件编码损坏导致周次空白
      const map = {
        "1": "\u5468\u4e00",
        "2": "\u5468\u4e8c",
        "3": "\u5468\u4e09",
        "4": "\u5468\u56db",
        "5": "\u5468\u4e94",
        "6": "\u5468\u516d",
        "7": "\u5468\u65e5"
      };
      let arr = days;
      if (typeof days === "string") arr = days.split(/[|,\s]+/).filter(Boolean);
      if (!Array.isArray(arr)) return "";
      return arr.map(d => map[String(d)] || d).join("\u3001");
    },
    formatLegacyWeekTime(row) {
      const days = this.formatWeekDays(row.UsingWeekDays || row.UsingWeekDayStr || row.usingWeekDays);
      const time = `${this.formatTime(row.StartTime || row.startTime)}-${this.formatTime(row.EndTime || row.endTime)}`;
      return days ? `${days} ${time}` : time;
    },
    /** 统一为「周一~周五 09:00-10:00」展示格式 */
    normalizeWeekTimeText(text) {
      let s = String(text || "").trim();
      if (!s) return "";
      s = s.replace(/\u301c/g, "~").replace(/～/g, "~");
      // 一~五 / 一-五 → 周一~周五
      s = s.replace(
        /(^|[^\u5468])([\u4e00\u4e8c\u4e09\u56db\u4e94\u516d\u65e5])\s*[~\-]\s*([\u4e00\u4e8c\u4e09\u56db\u4e94\u516d\u65e5])/g,
        (m, pre, a, b) => `${pre}\u5468${a}~\u5468${b}`
      );
      // 单独「一 09:00」这类少见情况：行首单字周次补「周」
      s = s.replace(
        /(^|[^\u5468\u4e00-\u9fff])([\u4e00\u4e8c\u4e09\u56db\u4e94\u516d\u65e5])(?=\s+\d)/g,
        (m, pre, d) => `${pre}\u5468${d}`
      );
      return s;
    },
    /** 将周次摘要拆成多段，便于标签展示 */
    splitWeekTimeSummary(summary) {
      const s = this.normalizeWeekTimeText(summary);
      if (!s || s === "—") return [];
      return s.split(/[；;]+/).map(x => this.normalizeWeekTimeText(x)).filter(Boolean);
    },
    weekTimeGroups(row) {
      return this.splitWeekTimeSummary(this.formatWeekTimeSummary(row));
    },
    /** 列表周次时间：优先用 DayDetails 本地拼，统一「周一~周五」格式 */
    formatWeekTimeSummary(row) {
      const label = {
        1: "\u5468\u4e00",
        2: "\u5468\u4e8c",
        3: "\u5468\u4e09",
        4: "\u5468\u56db",
        5: "\u5468\u4e94",
        6: "\u5468\u516d",
        7: "\u5468\u65e5"
      };
      const details = row.DayDetails || row.dayDetails || [];
      const enabled = (details || [])
        .filter(d => {
          const on = d.IsEnabled != null ? d.IsEnabled : d.isEnabled;
          return on !== false && on !== 0 && on !== "0";
        })
        .map(d => ({
          WeekDay: Number(d.WeekDay != null ? d.WeekDay : d.weekDay),
          StartTime: d.StartTime || d.startTime || "",
          EndTime: d.EndTime || d.endTime || ""
        }))
        .filter(d => d.WeekDay >= 1 && d.WeekDay <= 7)
        .sort((a, b) => a.WeekDay - b.WeekDay);

      if (!enabled.length) {
        const legacy = this.formatLegacyWeekTime(row);
        const apiSummary = row.WeekTimeSummary || row.weekTimeSummary || "";
        if (legacy) return this.normalizeWeekTimeText(legacy);
        if (apiSummary && /[\u4e00-\u9fff]/.test(apiSummary)) return this.normalizeWeekTimeText(apiSummary);
        return apiSummary && !/^\s*~/.test(apiSummary) ? this.normalizeWeekTimeText(apiSummary) : "";
      }

      const fmt = t => (t ? String(t).substring(0, 5) : "");
      const groups = [];
      let i = 0;
      while (i < enabled.length) {
        const start = enabled[i];
        let j = i;
        while (
          j + 1 < enabled.length &&
          enabled[j + 1].WeekDay === enabled[j].WeekDay + 1 &&
          enabled[j + 1].StartTime === start.StartTime &&
          enabled[j + 1].EndTime === start.EndTime
        ) {
          j += 1;
        }
        const dayText =
          i === j
            ? label[start.WeekDay]
            : `${label[start.WeekDay]}~${label[enabled[j].WeekDay]}`;
        groups.push(`${dayText} ${fmt(start.StartTime)}-${fmt(start.EndTime)}`);
        i = j + 1;
      }
      return groups.join("\uff1b");
    },
    async treeNodeClick(data, node) {
      const schId = resolveHeadTeacherWorkAttendanceSchoolIdFromTreeNode(node, data && data.value);
      onHeadTeacherWorkAttendanceSchoolChange(this, schId);
      this.currentSchoolName = pickSchoolDisplayName(node, data);
      this.currentItemId = null;
      this.schedules = [];
      this.configOverview = {
        ItemCount: 0,
        EnabledItemCount: 0,
        ScheduleCount: 0,
        EnabledScheduleCount: 0,
        Items: []
      };
      this.overviewPage = 1;
      this.overviewFilter = "all";
      if (!schId) {
        this.currentSchoolName = "";
        this.$message.warning("请选择学校节点");
        return;
      }
      this.pageLoading = true;
      try {
        await this.loadPlan();
        await Promise.all([this.loadItems(), this.loadConfigOverview()]);
      } finally {
        this.pageLoading = false;
      }
    },
    onTabClick() {
      if (!this.schoolId) return;
      if (this.activeTab === "plan") this.loadConfigOverview();
      if (this.activeTab === "item") this.loadItems();
      if (this.activeTab === "schedule") this.loadItems();
      if (this.activeTab === "admin") this.loadAdmins();
    },
    async loadAdmins() {
      if (!this.schoolId) return;
      this.adminLoading = true;
      try {
        const res = await getHeadTeacherWorkAttendanceAdmins(this.schoolId, this.adminPage, this.adminPageSize);
        const data = (res.data && res.data.response) || {};
        this.admins = Array.isArray(data) ? data : (data.data || []);
        this.adminTotal = Array.isArray(data) ? data.length : (data.dataCount || 0);
      } finally {
        this.adminLoading = false;
      }
    },
    onAdminTeacherPicked(people) {
      const existIds = new Set((this.admins || []).map(x => Number(x.TeacherMasterId || x.teacherMasterId)));
      const picked = (Array.isArray(people) ? people : [people])
        .filter(p => p && Number(p.id) > 0);
      const toAdd = picked.filter(p => !existIds.has(Number(p.id)));
      if (!toAdd.length) {
        this.$message.info("所选人员已是统计管理员");
        return;
      }
      const escapeHtml = s => String(s || "").replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
      const names = toAdd.map(p => escapeHtml(p.name)).join("、");
      const skipped = picked.length - toAdd.length;
      const message = `确认添加以下 ${toAdd.length} 人为统计管理员吗？<br/>${names}`
        + (skipped > 0 ? `<br/><span style="color:#909399;">另有 ${skipped} 人已是管理员，将跳过</span>` : "");
      this.$confirm(message, "确认添加", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.adminPickerVisible = false;
        this.saveAdmins(toAdd);
      }).catch(() => {});
    },
    async saveAdmins(people) {
      const results = await Promise.all(people.map(p => saveHeadTeacherWorkAttendanceAdmin({
        SchId: this.schoolId,
        TeacherMasterId: Number(p.id),
        Enabled: true
      }).catch(() => null)));
      const failCount = results.filter(r => !(r && r.data && r.data.success)).length;
      if (failCount) this.$message.warning(`已添加 ${people.length - failCount} 人，${failCount} 人失败`);
      else this.$message.success(`已添加 ${people.length} 名统计管理员`);
      this.adminPage = 1;
      await this.loadAdmins();
    },
    async removeAdmin(row) {
      await this.$confirm("确认移除该统计管理员吗？", "提示");
      await deleteHeadTeacherWorkAttendanceAdmin(this.schoolId, row.Id);
      await this.loadAdmins();
    },
    async loadPlan() {
      if (!this.schoolId) return;
      this.planLoading = true;
      try {
        const res = await getHeadTeacherWorkAttendancePlan(this.schoolId);
        if (res.data && res.data.success) {
          const data = res.data.response || {};
          this.planForm = {
            PlanName: data.PlanName || data.planName || "教职工工作考勤",
            IsEnabled: data.IsEnabled != null ? data.IsEnabled : data.isEnabled,
            AllowMakeup: data.AllowMakeup != null ? data.AllowMakeup : data.allowMakeup,
            MakeupDays: data.MakeupDays != null ? data.MakeupDays : data.makeupDays || 0
          };
        } else {
          this.$message.error((res.data && res.data.msg) || "加载方案失败");
        }
      } finally {
        this.planLoading = false;
      }
    },
    async savePlan() {
      if (!this.schoolId) return this.$message.warning("请先选择学校");
      if (!this.planForm.PlanName) return this.$message.warning("请填写方案名称");
      this.planSaving = true;
      try {
        const res = await saveHeadTeacherWorkAttendancePlan({
          SchId: this.schoolId,
          PlanName: this.planForm.PlanName,
          IsEnabled: this.planForm.IsEnabled,
          AllowMakeup: this.planForm.AllowMakeup,
          MakeupDays: this.planForm.AllowMakeup ? this.planForm.MakeupDays : 0
        });
        if (res.data && res.data.success) {
          this.$message.success(res.data.msg || "保存成功");
          await this.loadPlan();
        } else {
          this.$message.error((res.data && res.data.msg) || "保存失败");
        }
      } finally {
        this.planSaving = false;
      }
    },
    async loadConfigOverview() {
      if (!this.schoolId) return;
      this.overviewLoading = true;
      try {
        const res = await getHeadTeacherWorkAttendanceConfigOverview(this.schoolId);
        if (res.data && res.data.success) {
          const data = res.data.response || {};
          this.configOverview = {
            ItemCount: data.ItemCount || data.itemCount || 0,
            EnabledItemCount: data.EnabledItemCount || data.enabledItemCount || 0,
            ScheduleCount: data.ScheduleCount || data.scheduleCount || 0,
            EnabledScheduleCount: data.EnabledScheduleCount || data.enabledScheduleCount || 0,
            Items: data.Items || data.items || []
          };
          const maxPage = Math.max(1, Math.ceil((this.filteredOverviewItems || []).length / (this.overviewPageSize || 6)));
          if (this.overviewPage > maxPage) this.overviewPage = maxPage;
        } else {
          this.configOverview = {
            ItemCount: 0,
            EnabledItemCount: 0,
            ScheduleCount: 0,
            EnabledScheduleCount: 0,
            Items: []
          };
          this.$message.error((res.data && res.data.msg) || "加载配置总览失败");
        }
      } finally {
        this.overviewLoading = false;
      }
    },
    goItemSchedules(item) {
      if (!item) return;
      this.currentItemId = item.Id || item.id;
      this.schedulePage = 1;
      this.activeTab = "schedule";
      this.loadSchedules();
    },
    /** 卡片上最多预览 2 个时段 */
    previewSchedules(item) {
      return ((item && item.Schedules) || []).slice(0, 2);
    },
    editOverviewItem(item) {
      if (!item) return;
      this.activeTab = "item";
      const id = item.Id || item.id;
      const full = (this.items || []).find(x => (x.Id || x.id) === id);
      this.openItemDialog(full || item);
    },
    onItemPageChange(page) {
      this.itemPage = page || 1;
      this.loadItems();
    },
    onItemPageSizeChange(size) {
      this.itemPageSize = size || 10;
      this.itemPage = 1;
      this.loadItems();
    },
    async loadItems() {
      if (!this.schoolId) return;
      this.itemLoading = true;
      try {
        const res = await getHeadTeacherWorkAttendanceItems(this.schoolId, this.itemPage, this.itemPageSize);
        if (res.data && res.data.success) {
          const data = res.data.response || {};
          this.items = Array.isArray(data) ? data : (data.data || []);
          this.itemTotal = Array.isArray(data) ? data.length : (data.dataCount || 0);
        } else {
          this.items = [];
          this.$message.error((res.data && res.data.msg) || "加载项目失败");
        }
        this.ensureDefaultItemSelected();
        const maxPage = Math.max(1, Math.ceil((this.items || []).length / (this.itemPageSize || 10)));
        if (this.itemPage > maxPage) this.itemPage = maxPage;
        if (this.activeTab === "schedule") {
          if (this.currentItemId) await this.loadSchedules();
          else this.schedules = [];
        }
      } finally {
        this.itemLoading = false;
      }
    },
    /** 有项目时默认选中一个（优先已启用）；当前选中仍有效则保留 */
    ensureDefaultItemSelected() {
      const list = this.items || [];
      if (!list.length) {
        this.currentItemId = null;
        return;
      }
      const stillExists = list.some(x => (x.Id || x.id) === this.currentItemId);
      if (stillExists) return;
      const enabled = list.find(x => {
        const on = x.IsEnabled != null ? x.IsEnabled : x.isEnabled;
        return on !== false;
      });
      const pick = enabled || list[0];
      this.currentItemId = pick.Id || pick.id;
    },
    openItemDialog(row) {
      if (row) {
        this.itemDialogTitle = "编辑项目";
        this.itemForm = {
          Id: row.Id || row.id,
          ItemName: row.ItemName || row.itemName,
          ItemDesc: row.ItemDesc || row.itemDesc,
          SortNo: row.SortNo != null ? row.SortNo : row.sortNo,
          IsEnabled: row.IsEnabled != null ? row.IsEnabled : row.isEnabled,
          RequirePhoto: row.RequirePhoto != null ? row.RequirePhoto : row.requirePhoto,
          MinPhotoCount: row.MinPhotoCount != null ? row.MinPhotoCount : row.minPhotoCount,
          PhotoRequireDesc: row.PhotoRequireDesc || row.photoRequireDesc,
          RequireLivePhoto: row.RequireLivePhoto != null ? row.RequireLivePhoto : row.requireLivePhoto,
          RequireLocation: row.RequireLocation != null ? row.RequireLocation : row.requireLocation,
          LocationDesc: row.LocationDesc || row.locationDesc,
          AllowMakeup: row.AllowMakeup != null ? row.AllowMakeup : row.allowMakeup,
          MakeupDays: row.MakeupDays != null ? row.MakeupDays : row.makeupDays,
          WeeklyRequiredCount: row.WeeklyRequiredCount != null ? row.WeeklyRequiredCount : row.weeklyRequiredCount,
          ParticipantType: row.ParticipantType != null ? row.ParticipantType : 1,
          AssessmentMode: row.AssessmentMode != null ? row.AssessmentMode : 1
        };
      } else {
        this.itemDialogTitle = "新增项目";
        this.itemForm = this.createEmptyItem();
      }
      this.itemIncludeStaff = [];
      this.itemExcludeStaff = [];
      this.itemDialogVisible = true;
      if (this.itemForm.Id) this.loadItemStaff(this.itemForm.Id);
    },
    /** 加载项目的参与/排除名单。创建于 2026-10-07 */
    async loadItemStaff(itemId) {
      this.itemStaffLoading = true;
      try {
        const res = await getHeadTeacherWorkAttendanceItemStaff(this.schoolId, itemId);
        const list = (res.data && res.data.success && res.data.response) || [];
        const map = x => ({ TeacherMasterId: String(x.TeacherMasterId), TeacherName: x.TeacherName });
        this.itemIncludeStaff = list.filter(x => Number(x.IncludeType) !== 2).map(map);
        this.itemExcludeStaff = list.filter(x => Number(x.IncludeType) === 2).map(map);
      } finally {
        this.itemStaffLoading = false;
      }
    },
    /** 通讯录多选确认：以弹窗中的已选结果为准覆盖当前名单。创建于 2026-10-07 */
    onItemStaffPicked(people) {
      const list = (Array.isArray(people) ? people : [people])
        .filter(p => p && Number(p.id) > 0)
        .map(p => ({ TeacherMasterId: String(p.id), TeacherName: p.name }));
      if (this.itemForm.ParticipantType === 3) this.itemIncludeStaff = list;
      else this.itemExcludeStaff = list;
    },
    removeStaff(person) {
      const keep = x => x.TeacherMasterId !== person.TeacherMasterId;
      if (this.itemForm.ParticipantType === 3) this.itemIncludeStaff = this.itemIncludeStaff.filter(keep);
      else this.itemExcludeStaff = this.itemExcludeStaff.filter(keep);
    },
    clearCurrentStaff() {
      if (this.itemForm.ParticipantType === 3) this.itemIncludeStaff = [];
      else this.itemExcludeStaff = [];
    },
    async saveItem() {
      if (!this.schoolId) return this.$message.warning("请先选择学校");
      if (!this.itemForm.ItemName) return this.$message.warning("请填写项目名称");
      if (this.itemForm.ParticipantType === 3 && !this.itemIncludeStaff.length) {
        return this.$message.warning("自定义教职工请至少选择一名参与人员");
      }
      if (this.itemForm.AllowMakeup === true && (!this.itemForm.MakeupDays || this.itemForm.MakeupDays < 1)) {
        return this.$message.warning("项目允许补卡时，请设置项目补卡天数");
      }
      this.itemSaving = true;
      try {
        const payload = Object.assign({}, this.itemForm, { SchId: this.schoolId });
        const res = await saveHeadTeacherWorkAttendanceItem(payload);
        if (res.data && res.data.success) {
          const itemId = this.itemForm.Id || res.data.response;
          if (this.itemForm.ParticipantType !== 1 && itemId) {
            const staff = this.itemForm.ParticipantType === 3
              ? this.itemIncludeStaff.map(x => ({ TeacherMasterId: x.TeacherMasterId, IncludeType: 1 }))
              : this.itemExcludeStaff.map(x => ({ TeacherMasterId: x.TeacherMasterId, IncludeType: 2 }));
            const staffRes = await saveHeadTeacherWorkAttendanceItemStaff({ SchId: this.schoolId, ItemId: itemId, Staff: staff });
            if (!(staffRes.data && staffRes.data.success)) {
              this.$message.error((staffRes.data && staffRes.data.msg) || "项目已保存，但人员名单保存失败");
              this.itemForm.Id = itemId;
              await this.loadItems();
              return;
            }
          }
          this.$message.success(res.data.msg || "保存成功");
          this.itemDialogVisible = false;
          await this.loadItems();
          this.loadConfigOverview();
        } else {
          this.$message.error((res.data && res.data.msg) || "保存失败");
        }
      } finally {
        this.itemSaving = false;
      }
    },
    deleteItem(row) {
      const name = row.ItemName || row.itemName || "该项目";
      this.$confirm(
        "确认软删除【" + name + "】？<br/><br/>" +
          "• 配置列表中将不再显示（同时软删其时段）<br/>" +
          "• 已产生的打卡明细仍可正常查询（使用快照名称）<br/>" +
          "• 如需恢复，请手工在数据库将 IsDeleted 改回 0<br/><br/>" +
          "确定继续吗？",
        "删除考勤项目",
        {
          type: "warning",
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定删除",
          cancelButtonText: "取消"
        }
      )
        .then(async () => {
          const res = await disableHeadTeacherWorkAttendanceItem(this.schoolId, row.Id || row.id);
          if (res.data && res.data.success) {
            this.$message.success(res.data.msg || "已删除");
            if (this.currentItemId === (row.Id || row.id)) {
              this.currentItemId = null;
              this.schedules = [];
            }
            await this.loadItems();
            this.loadConfigOverview();
          } else {
            this.$message.error((res.data && res.data.msg) || "删除失败");
          }
        })
        .catch(() => {});
    },
    async enableItem(row) {
      const payload = {
        Id: row.Id || row.id,
        SchId: this.schoolId,
        ItemName: row.ItemName || row.itemName,
        ItemDesc: row.ItemDesc || row.itemDesc,
        SortNo: row.SortNo != null ? row.SortNo : row.sortNo,
        IsEnabled: true,
        RequirePhoto: row.RequirePhoto != null ? row.RequirePhoto : row.requirePhoto,
        MinPhotoCount: row.MinPhotoCount != null ? row.MinPhotoCount : row.minPhotoCount,
        PhotoRequireDesc: row.PhotoRequireDesc || row.photoRequireDesc,
        RequireLivePhoto: row.RequireLivePhoto != null ? row.RequireLivePhoto : row.requireLivePhoto,
        RequireLocation: row.RequireLocation != null ? row.RequireLocation : row.requireLocation,
        LocationDesc: row.LocationDesc || row.locationDesc,
        AllowMakeup: row.AllowMakeup != null ? row.AllowMakeup : row.allowMakeup,
        WeeklyRequiredCount: row.WeeklyRequiredCount != null ? row.WeeklyRequiredCount : row.weeklyRequiredCount
      };
      const res = await saveHeadTeacherWorkAttendanceItem(payload);
      if (res.data && res.data.success) {
        this.$message.success(res.data.msg || "已启用");
        await this.loadItems();
        this.loadConfigOverview();
      } else {
        this.$message.error((res.data && res.data.msg) || "启用失败");
      }
    },
    selectItemForSchedule(row) {
      this.currentItemId = row.Id || row.id;
      this.schedulePage = 1;
      this.activeTab = "schedule";
      this.loadSchedules();
    },
    async loadSchedules() {
      if (!this.schoolId || !this.currentItemId) {
        this.schedules = [];
        this.schedulePage = 1;
        return;
      }
      this.scheduleLoading = true;
      try {
        const res = await getHeadTeacherWorkAttendanceSchedules(
          this.schoolId, this.currentItemId, this.schedulePage, this.schedulePageSize);
        if (res.data && res.data.success) {
          const data = res.data.response || {};
          this.schedules = Array.isArray(data) ? data : (data.data || []);
          this.scheduleTotal = Array.isArray(data) ? data.length : (data.dataCount || 0);
        } else {
          this.schedules = [];
          this.$message.error((res.data && res.data.msg) || "加载时段失败");
        }
      } finally {
        this.scheduleLoading = false;
      }
    },
    onSchedulePageChange(page) {
      this.schedulePage = page || 1;
      this.loadSchedules();
    },
    onSchedulePageSizeChange(size) {
      this.schedulePageSize = size || 10;
      this.schedulePage = 1;
      this.loadSchedules();
    },
    openScheduleDialog(row) {
      if (!this.currentItemId) return this.$message.warning("请先选择项目");
      if (row) {
        this.scheduleDialogTitle = "编辑时段";
        const dayDetails = this.normalizeDayDetails(row);
        const mode = this.resolveUnifyMode(dayDetails);
        this.scheduleForm = {
          Id: row.Id || row.id,
          ScheduleName: row.ScheduleName || row.scheduleName,
          dateRange: [this.formatDate(row.EffectiveStartDate || row.effectiveStartDate), this.formatDate(row.EffectiveEndDate || row.effectiveEndDate)],
          UsingWeekDays: dayDetails.filter(d => d.IsEnabled).map(d => String(d.WeekDay)),
          DayDetails: dayDetails,
          unifyStart: mode.unifyStart,
          unifyEnd: mode.unifyEnd,
          unifyTime: mode.unifyTime,
          customWeekDays: mode.customWeekDays,
          SortNo: row.SortNo != null ? row.SortNo : row.sortNo,
          IsEnabled: row.IsEnabled != null ? row.IsEnabled : row.isEnabled
        };
      } else {
        this.scheduleDialogTitle = "新增时段";
        this.scheduleForm = this.createEmptySchedule();
      }
      this.scheduleDialogVisible = true;
    },
    async saveSchedule() {
      if (!this.schoolId || !this.currentItemId) return this.$message.warning("请先选择学校和项目");
      if (!this.scheduleForm.ScheduleName) return this.$message.warning("请填写时段名称");
      if (!this.scheduleForm.dateRange || this.scheduleForm.dateRange.length !== 2) return this.$message.warning("请选择生效日期");
      if (!this.scheduleForm.UsingWeekDays || !this.scheduleForm.UsingWeekDays.length) {
        return this.$message.warning("请选择打卡星期");
      }
      if (!this.scheduleForm.unifyStart || !this.scheduleForm.unifyEnd) {
        return this.$message.warning("请选择打卡起止时间");
      }
      if (String(this.scheduleForm.unifyStart) >= String(this.scheduleForm.unifyEnd)) {
        return this.$message.warning("开始时间须早于结束时间");
      }
      const dayDetails = this.buildDayDetailsForSave();
      const enabledDays = dayDetails.filter(d => d.IsEnabled);
      for (const d of enabledDays) {
        if (!d.StartTime || !d.EndTime) return this.$message.warning(`请完善星期${this.weekDayLabel(d.WeekDay)}的时间`);
        if (String(d.StartTime) >= String(d.EndTime)) {
          return this.$message.warning(`星期${this.weekDayLabel(d.WeekDay)}的开始时间须早于结束时间`);
        }
      }
      this.scheduleSaving = true;
      try {
        const payload = {
          Id: this.scheduleForm.Id || 0,
          SchId: this.schoolId,
          ItemId: this.currentItemId,
          ScheduleName: this.scheduleForm.ScheduleName,
          EffectiveStartDate: this.scheduleForm.dateRange[0],
          EffectiveEndDate: this.scheduleForm.dateRange[1],
          DayDetails: dayDetails,
          SortNo: this.scheduleForm.SortNo,
          IsEnabled: this.scheduleForm.IsEnabled
        };
        const res = await saveHeadTeacherWorkAttendanceSchedule(payload);
        if (res.data && res.data.success) {
          this.$message.success(res.data.msg || "保存成功");
          this.scheduleDialogVisible = false;
          await this.loadSchedules();
          this.loadConfigOverview();
        } else {
          this.$message.error((res.data && res.data.msg) || "保存失败");
        }
      } finally {
        this.scheduleSaving = false;
      }
    },
    deleteSchedule(row) {
      const name = row.ScheduleName || row.scheduleName || "该时段";
      this.$confirm(
        "确认软删除【" + name + "】？<br/><br/>" +
          "• 配置列表中将不再显示<br/>" +
          "• 已产生的打卡明细仍可正常查询<br/>" +
          "• 如需恢复，请手工在数据库将 IsDeleted 改回 0<br/><br/>" +
          "确定继续吗？",
        "删除考勤时段",
        {
          type: "warning",
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定删除",
          cancelButtonText: "取消"
        }
      )
        .then(async () => {
          const res = await disableHeadTeacherWorkAttendanceSchedule(this.schoolId, row.Id || row.id);
          if (res.data && res.data.success) {
            this.$message.success(res.data.msg || "已删除");
            await this.loadSchedules();
            this.loadConfigOverview();
          } else {
            this.$message.error((res.data && res.data.msg) || "删除失败");
          }
        })
        .catch(() => {});
    },
    async enableSchedule(row) {
      const payload = {
        Id: row.Id || row.id,
        SchId: this.schoolId,
        ItemId: this.currentItemId,
        ScheduleName: row.ScheduleName || row.scheduleName,
        EffectiveStartDate: this.formatDate(row.EffectiveStartDate || row.effectiveStartDate),
        EffectiveEndDate: this.formatDate(row.EffectiveEndDate || row.effectiveEndDate),
        DayDetails: this.normalizeDayDetails(row),
        SortNo: row.SortNo != null ? row.SortNo : row.sortNo,
        IsEnabled: true
      };
      const res = await saveHeadTeacherWorkAttendanceSchedule(payload);
      if (res.data && res.data.success) {
        this.$message.success(res.data.msg || "已启用");
        await this.loadSchedules();
        this.loadConfigOverview();
      } else {
        this.$message.error((res.data && res.data.msg) || "启用失败");
      }
    },
    async downloadScheduleTemplate() {
      this.templateDownloading = true;
      try {
        const res = await downloadHeadTeacherWorkAttendanceScheduleTemplate();
        downloadHeadTeacherWorkAttendanceBlob(res, "教职工工作考勤时段导入模板.xlsx");
      } catch (e) {
        this.$message.error("下载模板失败");
      } finally {
        this.templateDownloading = false;
      }
    },
    async exportSchedules() {
      if (!this.schoolId) return this.$message.warning("请先选择学校");
      this.scheduleExporting = true;
      try {
        const res = await exportHeadTeacherWorkAttendanceSchedules(this.schoolId, this.currentItemId || null);
        downloadHeadTeacherWorkAttendanceBlob(res, "教职工工作考勤时段配置.xlsx");
      } catch (e) {
        this.$message.error("导出失败");
      } finally {
        this.scheduleExporting = false;
      }
    },
    openScheduleExcelDialog(tab) {
      if (!this.schoolId) return this.$message.warning("请先选择学校");
      this.resetScheduleImport();
      this.scheduleExcelTab = typeof tab === "string" ? tab : "template";
      this.scheduleExcelVisible = true;
    },
    onScheduleExcelDialogClose() {
      this.resetScheduleImport();
    },
    openScheduleImport() {
      this.openScheduleExcelDialog("import");
    },
    resetScheduleImport() {
      this.scheduleImportStep = "upload";
      this.scheduleImportFile = null;
      this.scheduleImportRows = [];
      this.scheduleImportExpandedIndex = null;
      this.scheduleImportParseErrors = [];
      this.scheduleImportDetails = [];
      this.scheduleImportSuccessCount = 0;
      this.scheduleImportFailCount = 0;
      this.schedulePreviewLoading = false;
      this.scheduleImporting = false;
      if (this.$refs.scheduleImportUpload) {
        this.$refs.scheduleImportUpload.clearFiles();
      }
    },
    backToUploadStep() {
      this.scheduleImportStep = "upload";
      this.scheduleImportRows = [];
      this.scheduleImportExpandedIndex = null;
      this.scheduleImportDetails = [];
      this.scheduleImportParseErrors = [];
      this.scheduleImportSuccessCount = 0;
      this.scheduleImportFailCount = 0;
    },
    onScheduleImportFileChange(file) {
      this.scheduleImportFile = file && file.raw ? file.raw : null;
      this.scheduleImportParseErrors = [];
      this.scheduleImportRows = [];
      this.scheduleImportExpandedIndex = null;
      if (this.scheduleImportFile) {
        this.previewScheduleImport();
      }
    },
    onScheduleImportFileRemove() {
      this.scheduleImportFile = null;
      this.scheduleImportParseErrors = [];
      this.scheduleImportRows = [];
      this.scheduleImportExpandedIndex = null;
      this.scheduleImportStep = "upload";
    },
    normalizeExcelTime(val) {
      const s = String(val == null ? "" : val).trim();
      if (!s) return "";
      const pad = n => String(n).padStart(2, "0");
      // Excel 纯时间被读成 1899-12-xx / 1900-01-xx
      if (/^(1899|1900)-/.test(s)) {
        const d = new Date(s.replace(/-/g, "/"));
        if (!isNaN(d.getTime())) {
          return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
        }
      }
      const m = s.match(/^(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?$/);
      if (m) {
        return `${pad(+m[1])}:${pad(+m[2])}:${pad(+(m[3] || 0))}`;
      }
      return s;
    },
    normalizeImportPreviewRows(rows) {
      return (rows || []).map((r, idx) => ({
        RowNo: r.RowNo || r.rowNo || idx + 2,
        ItemName: r.ItemName || r.itemName || "",
        ScheduleName: r.ScheduleName || r.scheduleName || "",
        EffectiveStartDate: this.formatDate(r.EffectiveStartDate || r.effectiveStartDate),
        EffectiveEndDate: this.formatDate(r.EffectiveEndDate || r.effectiveEndDate),
        UsingWeekDays: r.UsingWeekDays || r.usingWeekDays || "",
        UnifyStartTime: this.normalizeExcelTime(r.UnifyStartTime || r.unifyStartTime || ""),
        UnifyEndTime: this.normalizeExcelTime(r.UnifyEndTime || r.unifyEndTime || ""),
        CustomDayTimes: r.CustomDayTimes || r.customDayTimes || "",
        SortNo: r.SortNo != null ? r.SortNo : (r.sortNo != null ? r.sortNo : 0),
        IsEnabled: r.IsEnabled != null ? r.IsEnabled : (r.isEnabled != null ? r.isEnabled : true)
      }));
    },
    async previewScheduleImport() {
      if (!this.scheduleImportFile) return this.$message.warning("请先选择 Excel 文件");
      this.schedulePreviewLoading = true;
      try {
        const res = await previewHeadTeacherWorkAttendanceScheduleImport(this.scheduleImportFile);
        if (res.data && res.data.success) {
          const data = res.data.response || {};
          this.scheduleImportParseErrors = data.ParseErrors || data.parseErrors || [];
          this.scheduleImportRows = this.normalizeImportPreviewRows(data.Rows || data.rows || []);
          if (!this.scheduleImportRows.length) {
            this.$message.warning(res.data.msg || "未解析到有效行");
            return;
          }
          this.scheduleImportStep = "preview";
          if (this.scheduleImportParseErrors.length) {
            this.$message.warning(`有 ${this.scheduleImportParseErrors.length} 条解析告警，其余行可继续调整导入`);
          }
        } else {
          this.$message.error((res.data && res.data.msg) || "解析失败");
        }
      } catch (e) {
        this.$message.error("解析失败");
      } finally {
        this.schedulePreviewLoading = false;
      }
    },
    removeScheduleImportRow(index) {
      this.scheduleImportRows.splice(index, 1);
      if (this.scheduleImportExpandedIndex == null) return;
      if (this.scheduleImportExpandedIndex === index) {
        this.scheduleImportExpandedIndex = null;
      } else if (this.scheduleImportExpandedIndex > index) {
        this.scheduleImportExpandedIndex -= 1;
      }
    },
    toggleImportRowExpand(index) {
      this.scheduleImportExpandedIndex =
        this.scheduleImportExpandedIndex === index ? null : index;
    },
    async submitScheduleImport() {
      if (!this.schoolId) return this.$message.warning("请先选择学校");
      if (!this.scheduleImportRows.length) return this.$message.warning("没有可导入的数据");
      this.scheduleImporting = true;
      try {
        const rows = this.scheduleImportRows.map(r => ({
          RowNo: r.RowNo,
          ItemName: r.ItemName,
          ScheduleName: r.ScheduleName,
          EffectiveStartDate: r.EffectiveStartDate,
          EffectiveEndDate: r.EffectiveEndDate,
          UsingWeekDays: r.UsingWeekDays,
          UnifyStartTime: r.UnifyStartTime,
          UnifyEndTime: r.UnifyEndTime,
          CustomDayTimes: r.CustomDayTimes,
          SortNo: r.SortNo || 0,
          IsEnabled: !!r.IsEnabled
        }));
        const res = await importHeadTeacherWorkAttendanceSchedulesByRows(this.schoolId, rows);
        if (res.data && res.data.success) {
          const data = res.data.response || {};
          this.scheduleImportSuccessCount = data.SuccessCount != null ? data.SuccessCount : (data.successCount || 0);
          this.scheduleImportFailCount = data.FailCount != null ? data.FailCount : (data.failCount || 0);
          const details = data.Details || data.details || [];
          this.scheduleImportDetails = details.map(d => ({
            RowNo: d.RowNo != null ? d.RowNo : d.rowNo,
            ItemName: d.ItemName || d.itemName || "",
            ScheduleName: d.ScheduleName || d.scheduleName || "",
            Success: !!(d.Success != null ? d.Success : d.success),
            IsUpdate: !!(d.IsUpdate != null ? d.IsUpdate : d.isUpdate),
            Message: d.Message || d.message || ""
          }));
          this.scheduleImportStep = "result";
          this.$message.success(res.data.msg || "导入完成");
          await this.loadItems();
          if (this.currentItemId) await this.loadSchedules();
          this.loadConfigOverview();
        } else {
          this.$message.error((res.data && res.data.msg) || "导入失败");
        }
      } catch (e) {
        this.$message.error("导入失败");
      } finally {
        this.scheduleImporting = false;
      }
    }
  }
};
</script>

<style scoped>
.htwa-config-page {
  --htwa-accent: #0891b2;
  --htwa-accent-soft: #ecfeff;
  --htwa-accent-border: #a5f3fc;
  height: 100%;
  max-height: 100%;
  min-height: 0;
  box-sizing: border-box;
  align-items: stretch;
}

.config-page-right {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  min-height: 0;
  height: 100% !important;
  max-height: 100%;
  box-sizing: border-box;
}

.config-panel {
  flex: 1;
  min-width: 0;
  min-height: 0;
  width: 100%;
  margin-top: 4px;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.config-top-bar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.org-display-card {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  padding: 10px 16px;
  background: linear-gradient(135deg, #ecfeff 0%, #cffafe 100%);
  border: 1px solid var(--htwa-accent-border);
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(8, 145, 178, 0.08);
  font-size: 14px;
  line-height: 1.4;
}

.org-icon {
  color: var(--htwa-accent);
  font-size: 16px;
  margin-right: 4px;
}

.org-label {
  color: #155e75;
  font-weight: 500;
}

.org-value {
  color: #0e7490;
  font-weight: 600;
  word-break: break-all;
}

.top-hint {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
}

.top-hint i {
  color: var(--htwa-accent);
}

.htwa-tabs {
  flex: 1;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.htwa-tabs >>> .el-tabs__header {
  flex-shrink: 0;
  margin-bottom: 12px;
}

.htwa-tabs >>> .el-tabs__content {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  position: relative;
}

/* 活动 pane 铺满内容区，避免高度塌陷导致外层滚动 */
.htwa-tabs >>> .el-tab-pane {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: auto !important;
  overflow: hidden;
}

.tab-scroll-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  padding-bottom: 8px;
}

.htwa-tabs >>> .el-tabs__item.is-active {
  color: var(--htwa-accent);
  font-weight: 600;
}

.htwa-tabs >>> .el-tabs__active-bar {
  background-color: var(--htwa-accent);
}

.htwa-tabs >>> .el-tabs__item:hover {
  color: #0e7490;
}

.setting-grid--plan {
  display: grid;
  grid-template-columns: minmax(300px, 420px) minmax(0, 1fr);
  gap: 16px;
  align-items: stretch;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}

@media (max-width: 1100px) {
  /* 窄屏：取消桌面满高锁定，改为内容自然撑开，由右侧/整页滚动，避免总览卡片划不动 */
  .htwa-config-page {
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
  }

  .config-page-right {
    height: auto !important;
    max-height: none !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
  }

  .config-panel,
  .htwa-tabs {
    height: auto !important;
    max-height: none;
    overflow: visible;
  }

  .htwa-tabs >>> .el-tabs__content {
    position: static;
    flex: none;
    overflow: visible;
    min-height: 0;
  }

  .htwa-tabs >>> .el-tab-pane {
    position: static !important;
    top: auto;
    left: auto;
    right: auto;
    bottom: auto;
    height: auto !important;
    overflow: visible;
  }

  .tab-scroll-panel {
    height: auto;
    overflow: visible;
    padding-bottom: 16px;
  }

  .setting-grid--plan {
    grid-template-columns: 1fr;
    height: auto;
    max-height: none;
    overflow: visible;
  }

  .setting-card--plan,
  .setting-card--overview {
    height: auto;
    max-height: none;
    overflow: visible;
  }

  .overview-body {
    overflow: visible;
  }

  .overview-scroll {
    flex: none;
    overflow: visible;
    min-height: 0;
  }
}

.setting-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e8ecf1;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.04);
  overflow: hidden;
}

.setting-card--plan {
  border-top: 3px solid var(--htwa-accent);
  align-self: stretch;
  max-height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

.setting-card--overview {
  border-top: 3px solid #67e8f9;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.setting-card-icon--overview {
  background: #ecfeff;
  color: #0891b2;
}

.overview-refresh {
  margin-left: auto;
  color: #0891b2 !important;
  flex-shrink: 0;
}

.overview-body {
  flex: 1;
  min-height: 0;
  padding: 12px 16px 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.overview-kpi {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 14px;
  margin-bottom: 12px;
  border-radius: 12px;
  background: linear-gradient(135deg, #ecfeff 0%, #f0fdfa 55%, #fff 100%);
  border: 1px solid #a5f3fc;
}

.overview-toolbar {
  flex-shrink: 0;
}

.overview-scroll {
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 2px;
}

.overview-scroll .pagination-wrap {
  position: sticky;
  bottom: 0;
  z-index: 1;
  margin-top: 8px;
  padding-top: 4px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 28%);
}

.overview-kpi-main {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 6px;
  color: #164e63;
}

.overview-kpi-num {
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
}

.overview-kpi-num--accent {
  color: #0891b2;
}

.overview-kpi-unit {
  font-size: 13px;
  color: #64748b;
}

.overview-kpi-split {
  margin: 0 2px;
  color: #cbd5e1;
}

.overview-kpi-side {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.overview-kpi-pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  color: #475569;
  background: #fff;
  border: 1px solid #e2e8f0;
}

.overview-kpi-pill--ok {
  color: #0e7490;
  background: #ecfeff;
  border-color: #a5f3fc;
  font-weight: 600;
}

.overview-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}

.overview-empty {
  padding: 36px 12px;
  text-align: center;
  font-size: 13px;
  color: #94a3b8;
  line-height: 1.6;
}

.overview-empty i {
  font-size: 28px;
  color: #cbd5e1;
  margin-bottom: 8px;
}

.overview-empty p {
  margin: 0 0 4px;
}

.overview-dot {
  color: #cbd5e1;
}

.overview-card-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

@media (max-width: 1200px) {
  .overview-card-grid {
    grid-template-columns: 1fr;
  }
}

.ov-card {
  display: flex;
  flex-direction: column;
  min-height: 168px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.ov-card:hover {
  border-color: #67e8f9;
  box-shadow: 0 8px 20px rgba(8, 145, 178, 0.08);
}

.ov-card.is-empty {
  background: #fafbfc;
}

.ov-card.is-off {
  opacity: 0.78;
}

.ov-card-head {
  padding: 12px 14px 8px;
}

.ov-card-title-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.ov-card-title {
  flex: 1;
  min-width: 0;
  font-size: 15px;
  font-weight: 600;
  color: #164e63;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ov-card-meta {
  margin-top: 6px;
  font-size: 12px;
  color: #64748b;
}

.ov-card-meta b {
  color: #0e7490;
  font-weight: 600;
}

.ov-card-body {
  flex: 1;
  padding: 0 14px 4px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ov-card-sch {
  padding: 8px 10px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
}

.ov-card-sch-name {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  margin-bottom: 6px;
}

.ov-card-sch-name i {
  color: #0891b2;
}

.ov-card-sch-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ov-card-more {
  font-size: 12px;
  color: #94a3b8;
  padding-left: 2px;
}

.ov-card-empty {
  flex: 1;
  margin: 0 14px;
  padding: 18px 12px;
  border-radius: 8px;
  border: 1px dashed #e2e8f0;
  color: #94a3b8;
  font-size: 12px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ov-card-foot {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
  padding: 6px 10px 8px;
  border-top: 1px solid #f1f5f9;
  margin-top: auto;
}

.ov-chip {
  display: inline-flex;
  align-items: center;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 12px;
  line-height: 1.4;
  color: #475569;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
}

.ov-chip--time {
  color: #0e7490;
  background: #ecfeff;
  border-color: #a5f3fc;
  font-weight: 600;
}

.pagination-wrap {
  flex-shrink: 0;
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}

.pagination-wrap >>> .el-pagination {
  width: auto;
  margin: 0;
  display: inline-flex;
  align-items: center;
  float: none;
  padding: 4px 8px;
  box-shadow: none;
  background: transparent;
}

.week-time-cell {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: center;
  padding: 2px 0;
}

.week-time-chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  line-height: 1.5;
  color: #0e7490;
  background: #ecfeff;
  border: 1px solid #a5f3fc;
  white-space: nowrap;
}

.week-time-empty {
  color: #c0c4cc;
}

.setting-card-head {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px 12px;
  background: linear-gradient(180deg, #f8fafc 0%, #fff 100%);
  border-bottom: 1px solid #f0f2f5;
}

.setting-card-icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.setting-card-icon--plan {
  background: var(--htwa-accent-soft);
  color: var(--htwa-accent);
}

.setting-card-head-text {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.setting-card-name {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.setting-card-sub {
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}

.setting-body {
  padding: 4px 0 12px;
}

.setting-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 14px 18px;
  border-bottom: 1px solid #f5f7fa;
}

.setting-row:last-of-type {
  border-bottom: none;
}

.setting-row-text {
  flex: 1;
  min-width: 0;
  padding-top: 2px;
}

.setting-row-label {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}

.setting-row-desc {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
  line-height: 1.55;
}

.setting-control {
  width: 220px;
  flex-shrink: 0;
}

.setting-control-num {
  flex-shrink: 0;
}

.setting-row-switch {
  flex-shrink: 0;
  margin-top: 2px;
}

.setting-footer {
  padding: 8px 18px 6px;
}

.panel-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin: 8px 0 14px;
}

.panel-toolbar-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.panel-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.panel-sub {
  font-size: 12px;
  color: #909399;
  line-height: 1.45;
}

.panel-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.item-select {
  width: 220px;
}

.item-config-form .el-form-item {
  margin-bottom: 14px;
}

.item-config-form .el-form-item__content > .el-input,
.item-config-form .el-form-item__content > .el-textarea {
  width: 100%;
}

.htwa-table {
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.htwa-table >>> .el-table__header-wrapper {
  flex-shrink: 0;
}

.htwa-table >>> .el-table__body-wrapper {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

/* 去掉表格外框，避免与右侧白色卡片边形成「双线」 */
.htwa-table.el-table--border {
  border: none;
}

.htwa-table.el-table--border::before,
.htwa-table.el-table--border::after {
  display: none;
}

.htwa-table.el-table--border >>> th.el-table__cell:last-child,
.htwa-table.el-table--border >>> td.el-table__cell:last-child {
  border-right: none;
}

.link-cyan {
  color: var(--htwa-accent) !important;
}

.link-danger {
  color: #f56c6c !important;
}

.field-hint {
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
  margin-top: 4px;
}

/* 项目参与/排除人员选择区。创建于 2026-10-07 */
.staff-picker-box {
  padding: 8px 12px;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  background: #fafbfc;
}

.staff-picker-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  line-height: 28px;
}

.staff-picker-count {
  font-size: 13px;
  color: #606266;
}

.staff-picker-count b {
  color: #2563eb;
}

.staff-picker-empty {
  font-size: 12px;
  color: #909399;
}

.staff-picker-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-height: 120px;
  margin-top: 6px;
  overflow-y: auto;
}

.unify-time-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.unify-time-sep {
  color: #909399;
}

.day-table {
  width: 100%;
}

.excel-dialog-head {
  display: flex;
  align-items: center;
  gap: 12px;
}

.excel-dialog-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #ecfeff 0%, #cffafe 100%);
  color: #0891b2;
  font-size: 20px;
  flex-shrink: 0;
}

.excel-dialog-title {
  font-size: 16px;
  font-weight: 600;
  color: #164e63;
  line-height: 1.3;
}

.excel-dialog-sub {
  margin-top: 2px;
  font-size: 12px;
  color: #64748b;
  font-weight: 400;
}

.excel-seg {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
  padding: 4px;
  margin-bottom: 16px;
  background: #f1f5f9;
  border-radius: 10px;
}

.excel-seg-item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 0;
  padding: 9px 8px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #64748b;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.excel-seg-item:hover {
  color: #0e7490;
  background: rgba(255, 255, 255, 0.65);
}

.excel-seg-item.is-active {
  background: #fff;
  color: #0891b2;
  font-weight: 600;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}

.excel-panel {
  min-height: 320px;
}

.excel-hero-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 18px;
  border-radius: 12px;
  background: linear-gradient(135deg, #ecfeff 0%, #f0fdfa 55%, #fff 100%);
  border: 1px solid #a5f3fc;
}

.excel-hero-copy {
  min-width: 0;
  flex: 1;
}

.excel-hero-copy h4 {
  margin: 0 0 6px;
  font-size: 15px;
  font-weight: 600;
  color: #164e63;
}

.excel-hero-copy p {
  margin: 0;
  font-size: 13px;
  line-height: 1.55;
  color: #475569;
}

.excel-cta {
  flex-shrink: 0;
}

.excel-rule-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin-top: 12px;
}

.excel-rule {
  padding: 10px 12px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.excel-rule-k {
  font-size: 12px;
  font-weight: 600;
  color: #0891b2;
  margin-bottom: 4px;
}

.excel-rule-v {
  font-size: 12px;
  line-height: 1.5;
  color: #475569;
}

.excel-rule-v code {
  padding: 1px 5px;
  border-radius: 4px;
  background: #ecfeff;
  color: #0e7490;
  font-size: 12px;
}

.excel-scope-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 8px 12px;
  border-radius: 999px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  font-size: 13px;
  color: #334155;
}

.excel-scope-chip i {
  color: #0891b2;
}

.excel-steps {
  display: flex;
  align-items: center;
  gap: 0;
  margin-bottom: 16px;
  padding: 4px 0;
}

.excel-step {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #94a3b8;
  font-size: 13px;
  white-space: nowrap;
}

.excel-step-no {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  background: #e2e8f0;
  color: #64748b;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.excel-step.is-active {
  color: #0e7490;
  font-weight: 600;
}

.excel-step.is-active .excel-step-no {
  background: #0891b2;
  color: #fff;
}

.excel-step.is-done {
  color: #0f766e;
}

.excel-step.is-done .excel-step-no {
  background: #99f6e4;
  color: #0f766e;
}

.excel-step-line {
  flex: 1;
  height: 2px;
  margin: 0 10px;
  background: #e2e8f0;
  border-radius: 1px;
  min-width: 24px;
  transition: background-color 0.2s ease;
}

.excel-step-line.is-on {
  background: #67e8f9;
}

.excel-upload-layout {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 14px;
  align-items: stretch;
}

.excel-uploader {
  width: 100%;
}

.excel-uploader >>> .el-upload {
  width: 100%;
}

.excel-uploader >>> .el-upload-dragger {
  width: 100%;
  height: 168px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  border: 1.5px dashed #a5f3fc;
  background: linear-gradient(180deg, #ecfeff 0%, #fff 70%);
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.excel-uploader >>> .el-upload-dragger:hover {
  border-color: #0891b2;
  background: #ecfeff;
}

.excel-uploader-icon {
  font-size: 40px !important;
  color: #0891b2 !important;
  margin: 0 0 8px !important;
}

.excel-uploader >>> .el-upload__text {
  color: #334155;
  font-size: 13px;
}

.excel-uploader >>> .el-upload__text em {
  color: #0891b2;
  font-style: normal;
  font-weight: 600;
}

.excel-uploader-hint {
  margin-top: 6px;
  font-size: 12px;
  color: #94a3b8;
}

.excel-upload-side {
  padding: 14px 16px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.excel-side-title {
  font-size: 13px;
  font-weight: 600;
  color: #164e63;
  margin-bottom: 10px;
}

.excel-side-list {
  margin: 0;
  padding-left: 18px;
  font-size: 12px;
  line-height: 1.7;
  color: #475569;
}

.excel-preview-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
  font-size: 13px;
  color: #475569;
}

.excel-preview-bar b {
  color: #0891b2;
}

.excel-preview-list {
  max-height: 360px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-right: 2px;
}

.excel-preview-item {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.excel-preview-item.is-open {
  border-color: #67e8f9;
  box-shadow: 0 0 0 1px rgba(8, 145, 178, 0.12);
}

.excel-preview-summary {
  display: grid;
  grid-template-columns: 44px minmax(0, 1.4fr) minmax(0, 1.1fr) 96px auto auto;
  align-items: center;
  gap: 8px 10px;
  padding: 10px 12px;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.excel-preview-summary:hover {
  background: #f8fafc;
}

.excel-preview-rowno {
  font-size: 12px;
  font-weight: 700;
  color: #0891b2;
}

.excel-preview-summary-main {
  min-width: 0;
  display: flex;
  align-items: baseline;
  gap: 4px;
  overflow: hidden;
}

.excel-preview-title {
  font-size: 13px;
  font-weight: 600;
  color: #164e63;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.excel-preview-sep {
  color: #94a3b8;
  flex-shrink: 0;
}

.excel-preview-sub {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.excel-preview-meta,
.excel-preview-time {
  font-size: 12px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.excel-preview-time {
  color: #0e7490;
  font-weight: 600;
}

.excel-preview-summary-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 2px;
  white-space: nowrap;
}

.excel-preview-editor {
  padding: 0 12px 12px;
  border-top: 1px dashed #e2e8f0;
  background: #f8fafc;
}

.excel-preview-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px 10px;
  padding-top: 10px;
}

.ep-field {
  min-width: 0;
}

.ep-field--2 {
  grid-column: span 2;
}

.ep-field--3 {
  grid-column: span 3;
}

.ep-field--full {
  grid-column: 1 / -1;
}

.ep-field label {
  display: block;
  margin-bottom: 4px;
  font-size: 12px;
  color: #64748b;
  line-height: 1.2;
}

.ep-switch-wrap {
  min-height: 28px;
  display: flex;
  align-items: center;
}

@media (max-width: 720px) {
  .excel-preview-summary {
    grid-template-columns: 40px minmax(0, 1fr) auto;
  }

  .excel-preview-meta,
  .excel-preview-time {
    display: none;
  }

  .excel-preview-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .ep-field--3 {
    grid-column: 1 / -1;
  }
}

.excel-result-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 12px;
}

.excel-result-card {
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
}

.excel-result-card--ok {
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.excel-result-card--fail {
  background: #fef2f2;
  border-color: #fecaca;
}

.excel-result-num {
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
  color: #164e63;
}

.excel-result-card--ok .excel-result-num {
  color: #16a34a;
}

.excel-result-card--fail .excel-result-num {
  color: #dc2626;
}

.excel-result-label {
  margin-top: 2px;
  font-size: 12px;
  color: #64748b;
}

.import-preview-table {
  width: 100%;
}

.import-errors {
  margin: 12px 0 0;
  padding: 10px 12px;
  border-radius: 8px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
  font-size: 12px;
  max-height: 160px;
  overflow: auto;
}

.import-errors ul {
  margin: 6px 0 0;
  padding-left: 18px;
}

.excel-dialog-footer {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
}

@media (max-width: 900px) {
  .item-config-form .el-col-12 {
    width: 100%;
  }

  .excel-upload-layout {
    grid-template-columns: 1fr;
  }

  .excel-hero-card {
    flex-direction: column;
    align-items: stretch;
  }

  .excel-cta {
    width: 100%;
  }
}

.empty-tip {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  padding: 24px;
}

.empty-tip-inner {
  text-align: center;
  max-width: 300px;
}

.empty-icon {
  font-size: 48px;
  color: #dcdfe6;
}

.empty-title {
  margin: 12px 0 6px;
  font-size: 15px;
  font-weight: 500;
  color: #606266;
}

.empty-desc {
  margin: 0;
  font-size: 13px;
  color: #909399;
  line-height: 1.55;
}
</style>

<style>
/* append-to-body 弹窗外壳，需非 scoped */
.htwa-excel-dialog {
  width: 860px !important;
  height: 560px;
  margin-top: 8vh !important;
  display: flex;
  flex-direction: column;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.18);
}

.htwa-excel-dialog .el-dialog__header {
  flex-shrink: 0;
  padding: 18px 20px 10px;
  border-bottom: none;
}

.htwa-excel-dialog .el-dialog__title {
  width: 100%;
}

.htwa-excel-dialog .el-dialog__body {
  flex: 1;
  min-height: 0;
  height: 390px;
  padding: 8px 20px 6px;
  overflow-x: hidden;
  overflow-y: auto;
}

.htwa-excel-dialog .el-dialog__footer {
  flex-shrink: 0;
  padding: 12px 20px 18px;
  border-top: 1px solid #f1f5f9;
}

.htwa-excel-dialog .el-button--primary {
  background-color: #0891b2;
  border-color: #0891b2;
}

.htwa-excel-dialog .el-button--primary:hover,
.htwa-excel-dialog .el-button--primary:focus {
  background-color: #0e7490;
  border-color: #0e7490;
}

@media (prefers-reduced-motion: reduce) {
  .htwa-excel-dialog * {
    transition: none !important;
  }
}

/* 新增/编辑时段弹窗（append-to-body，需非 scoped），主色跟随系统按钮蓝。最后修改：2026-10-04 */
.sch-dialog {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.18);
}

.sch-dialog .el-dialog__header {
  padding: 16px 22px 12px;
  border-bottom: 1px solid #f1f5f9;
}

.sch-dialog .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
}

.sch-dialog .el-dialog__body {
  max-height: 66vh;
  overflow-y: auto;
  padding: 14px 22px 4px;
}

.sch-dialog .el-dialog__footer {
  padding: 12px 22px 16px;
  border-top: 1px solid #f1f5f9;
}

.sch-dialog .sch-item-banner {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 14px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #eff6ff;
  color: #1e40af;
  font-size: 13px;
}

.sch-dialog .sch-section {
  padding-bottom: 6px;
  margin-bottom: 14px;
}

.sch-dialog .sch-section + .sch-section {
  padding-top: 14px;
  border-top: 1px dashed #e2e8f0;
}

.sch-dialog .sch-section-title {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.sch-dialog .sch-title-text {
  position: relative;
  padding-left: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  line-height: 18px;
}

.sch-dialog .sch-title-text::before {
  content: "";
  position: absolute;
  left: 0;
  top: 2px;
  width: 3px;
  height: 14px;
  border-radius: 2px;
  background: #2563eb;
}

.sch-dialog .sch-form .el-form-item {
  margin-bottom: 14px;
}

.sch-dialog .sch-form .el-form-item__label {
  padding-bottom: 4px;
  line-height: 20px;
  font-size: 13px;
  color: #475569;
}

.sch-dialog .sch-grid {
  display: grid;
  grid-template-columns: 1fr 1.3fr;
  gap: 0 18px;
}

.sch-dialog .sch-field-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.sch-dialog .sch-field-label {
  font-size: 13px;
  color: #475569;
}

.sch-dialog .sch-required {
  margin-right: 4px;
  font-style: normal;
  color: #f56c6c;
}

.sch-dialog .sch-quick {
  display: inline-flex;
  gap: 2px;
}

.sch-dialog .sch-quick a {
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 12px;
  color: #2563eb;
  cursor: pointer;
  transition: background-color 0.18s ease;
}

.sch-dialog .sch-quick a:hover {
  background: #eff6ff;
}

.sch-dialog .sch-week-pills {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
  margin-bottom: 16px;
}

.sch-dialog .sch-pill {
  height: 32px;
  border: 1px solid #dbe2ea;
  border-radius: 8px;
  background: #fff;
  color: #475569;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}

.sch-dialog .sch-pill:hover {
  border-color: #93c5fd;
  color: #2563eb;
}

.sch-dialog .sch-pill.is-on {
  background: #eff6ff;
  border-color: #2563eb;
  color: #1d4ed8;
  font-weight: 600;
}

.sch-dialog .sch-pill:focus-visible,
.sch-dialog .sch-mode-item:focus-visible,
.sch-dialog .sch-mini-chip:focus-visible {
  outline: 2px solid #93c5fd;
  outline-offset: 2px;
}

.sch-dialog .sch-mode-seg {
  display: inline-flex;
  padding: 2px;
  border-radius: 8px;
  background: #f1f5f9;
}

.sch-dialog .sch-mode-item {
  border: none;
  background: transparent;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 12px;
  color: #64748b;
  cursor: pointer;
  transition: background-color 0.18s ease, color 0.18s ease;
}

.sch-dialog .sch-mode-item.is-active {
  background: #fff;
  color: #1d4ed8;
  font-weight: 600;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);
}

.sch-dialog .sch-time-line {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.sch-dialog .sch-time-picker.el-date-editor {
  width: 130px;
}

.sch-dialog .sch-time-sep {
  font-size: 13px;
  color: #94a3b8;
}

.sch-dialog .sch-time-tip {
  font-size: 12px;
  color: #94a3b8;
}

.sch-dialog .sch-custom-box {
  margin-bottom: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
}

.sch-dialog .sch-custom-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 12px;
  color: #64748b;
}

.sch-dialog .sch-mini-chip {
  height: 24px;
  padding: 0 10px;
  border: 1px solid #dbe2ea;
  border-radius: 999px;
  background: #fff;
  font-size: 12px;
  color: #475569;
  cursor: pointer;
  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}

.sch-dialog .sch-mini-chip:hover {
  border-color: #93c5fd;
  color: #2563eb;
}

.sch-dialog .sch-mini-chip.is-on {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.sch-dialog .sch-custom-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
}

.sch-dialog .sch-custom-day {
  width: 36px;
  font-size: 13px;
  font-weight: 600;
  color: #1d4ed8;
}

.sch-dialog .sch-custom-remove {
  padding: 4px;
  border-radius: 4px;
  color: #94a3b8;
  cursor: pointer;
  transition: color 0.18s ease, background-color 0.18s ease;
}

.sch-dialog .sch-custom-remove:hover {
  color: #ef4444;
  background: #fef2f2;
}

.sch-dialog .sch-preview {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #eff6ff;
}

.sch-dialog .sch-preview.is-empty {
  background: #f8fafc;
}

.sch-dialog .sch-preview-label {
  font-size: 12px;
  color: #64748b;
}

.sch-dialog .sch-preview-lines {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.sch-dialog .sch-preview-chip {
  padding: 2px 10px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid #bfdbfe;
  font-size: 12px;
  font-weight: 500;
  color: #1d4ed8;
}

@media (prefers-reduced-motion: reduce) {
  .sch-dialog * {
    transition: none !important;
  }
}
</style>
